"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[469],{

/***/ 46774:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ inventory_overview_InventoryManagementPage)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-page@0.4.3_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-page/dist/index.js
var dist = __webpack_require__(48534);
// EXTERNAL MODULE: ./src/ex-web-packages/index.ts
var ex_web_packages = __webpack_require__(26298);
// EXTERNAL MODULE: ./src/client/inventory/components/index.ts + 5 modules
var components = __webpack_require__(6944);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@6.15.0_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/react-router-dom/dist/index.js
var react_router_dom_dist = __webpack_require__(58311);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Menu/Menu.js
var Menu = __webpack_require__(99313);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(64432);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(77572);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/esm/LocalShipping.js
var LocalShipping = __webpack_require__(50384);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var user_context_provider_dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+role-definitions@3.0.0/node_modules/@elephant-healthcare/role-definitions/dist/module.js
var role_definitions_dist_module = __webpack_require__(4377);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./src/client/inventory/permissions.ts
var permissions = __webpack_require__(64174);
// EXTERNAL MODULE: ./src/client/inventory/routing/links.ts
var links = __webpack_require__(57706);
;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/ReceiveDrawer/useReceiveDrawerState.ts

function useReceiveDrawerState() {
  const [isOpen, setOpen] = (0,react.useState)(false);
  const openMenu = (0,react.useCallback)(() => setOpen(true), []);
  const closeMenu = (0,react.useCallback)(() => setOpen(false), []);
  const toggleMenu = (0,react.useCallback)(() => setOpen((val) => !val), []);
  return { isOpen, openMenu, closeMenu, toggleMenu };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash.merge@4.6.2/node_modules/lodash.merge/index.js
var lodash_merge = __webpack_require__(72266);
var lodash_merge_default = /*#__PURE__*/__webpack_require__.n(lodash_merge);
// EXTERNAL MODULE: ./src/client/inventory/types.ts
var types = __webpack_require__(58998);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/useSortByOptions.ts


function useSortByOptions() {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return {
    [types/* InventorySearchOrderProperty.NAME */.I.NAME]: {
      label: formatMessage({
        id: "inventory.overview.list.sort.option.alphabetical",
        defaultMessage: "A to Z"
      }),
      field: types/* InventorySearchOrderProperty.NAME */.I.NAME
    },
    [types/* InventorySearchOrderProperty.UPDATED_AT */.I.UPDATED_AT]: {
      label: formatMessage({
        id: "inventory.overview.list.sort.option.updated_at",
        defaultMessage: "Last Updated"
      }),
      field: types/* InventorySearchOrderProperty.UPDATED_AT */.I.UPDATED_AT
    },
    [types/* InventorySearchOrderProperty.EXPIRY_DATE */.I.EXPIRY_DATE]: {
      label: formatMessage({
        id: "inventory.overview.list.sort.option.expiry_date",
        defaultMessage: "Expiry Date"
      }),
      field: types/* InventorySearchOrderProperty.EXPIRY_DATE */.I.EXPIRY_DATE
    },
    [types/* InventorySearchOrderProperty.STOCK_LEVEL */.I.STOCK_LEVEL]: {
      label: formatMessage({
        id: "inventory.overview.list.sort.option.stock_level",
        defaultMessage: "Quantity"
      }),
      field: types/* InventorySearchOrderProperty.STOCK_LEVEL */.I.STOCK_LEVEL,
      direction: "ASC"
    }
  };
}
/* harmony default export */ const inventory_overview_useSortByOptions = (useSortByOptions);

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/InventoryFilterState.ts




function useInventoryTableFilterState() {
  const sortByOptions = inventory_overview_useSortByOptions();
  const defaultInventorySortBy = sortByOptions[types/* InventorySearchOrderProperty.UPDATED_AT */.I.UPDATED_AT];
  const defaultValues = {
    loading: false,
    locationId: null,
    sortBy: defaultInventorySortBy,
    searchTerm: "",
    defaultInventorySortBy
  };
  const [sortBy, setSortBy] = (0,react.useState)(defaultValues.sortBy);
  const [searchTerm, setSearchTerm] = (0,react.useState)(
    defaultValues.searchTerm
  );
  const [locationId, setLocationId] = (0,react.useState)(
    defaultValues.locationId
  );
  const [loading, setLoading] = (0,react.useState)(defaultValues.loading);
  const [refreshKey, setRefreshKey] = (0,react.useState)(0);
  const reset = (resetValues) => {
    const mergedValues = lodash_merge_default()(
      defaultValues,
      resetValues
    );
    setLoading(mergedValues.loading);
    setLocationId(mergedValues.locationId);
    setSearchTerm(mergedValues.searchTerm);
    setSortBy(mergedValues.sortBy);
  };
  return {
    loading,
    setLoading,
    locationId,
    setLocationId,
    sortBy,
    setSortBy,
    searchTerm,
    setSearchTerm,
    reset,
    defaultInventorySortBy,
    refreshKey,
    incrementRefreshKey: () => setRefreshKey(refreshKey + 1)
  };
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/MoveDrawer/useMoveDrawerState.ts

function useMoveDrawerState() {
  const [isOpen, setOpen] = (0,react.useState)(false);
  const openMenu = (0,react.useCallback)(() => setOpen(true), []);
  const closeMenu = (0,react.useCallback)(() => setOpen(false), []);
  const toggleMenu = (0,react.useCallback)(() => setOpen((val) => !val), []);
  return {
    isOpen,
    openMenu,
    closeMenu,
    toggleMenu,
    showCheckboxes: isOpen
  };
}

// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.9/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(85961);
// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/MoveDrawer/useMoveForm.ts




const moveSchema = (destinationLocationId) => es.object({
  sourceLotId: es.string().required(),
  locationId: es.string().notOneOf(
    [destinationLocationId],
    "Can't move a lot to the same location"
  ).required(),
  quantityToMove: es.number().integer().min(1).max(
    es.ref("currentLotQuantity"),
    "Must be less than or equal to the current quantity"
  )
});
const movesValidationSchema = es.object({
  destinationLocationId: es.string().required("Please select a location"),
  moves: es.mixed().when("destinationLocationId", (destinationLocationId) => {
    return es.array(moveSchema(destinationLocationId)).min(1);
  }).default([])
});
function useMoveForm() {
  const form = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(movesValidationSchema)
  });
  const { fields, append, remove } = (0,index_esm/* useFieldArray */.Dq)({
    control: form.control,
    name: "moves",
    keyName: "key"
  });
  const isLotSelected = (0,react.useCallback)(
    (lotId) => !!fields.find(({ sourceLotId }) => sourceLotId === lotId),
    [fields]
  );
  const handleLotClick = (0,react.useCallback)(
    (moveDetails) => {
      const index = fields.findIndex(
        ({ sourceLotId }) => sourceLotId === moveDetails.sourceLotId
      );
      if (index >= 0) {
        remove(index);
      } else {
        append(moveDetails);
      }
    },
    [fields]
  );
  return {
    form,
    sourceLotFields: fields,
    isLotSelected,
    handleLotClick,
    removeLot: remove
  };
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/InventoryContext.tsx






const InventoryContext = (0,react.createContext)(null);
const useReceiveDrawerContext = () => {
  var _a;
  return (_a = (0,react.useContext)(InventoryContext)) == null ? void 0 : _a.receiveDrawerState;
};
const useMoveDrawerContext = () => {
  var _a;
  return (_a = (0,react.useContext)(InventoryContext)) == null ? void 0 : _a.moveDrawerState;
};
const useMoveFormContext = () => {
  var _a;
  return (_a = (0,react.useContext)(InventoryContext)) == null ? void 0 : _a.moveForm;
};
const useInventoryTableFilterContext = () => {
  var _a;
  return (_a = (0,react.useContext)(InventoryContext)) == null ? void 0 : _a.inventoryTableFilterState;
};
function InventoryContextProvider({
  children
}) {
  const receiveDrawerState = useReceiveDrawerState();
  const moveDrawerState = useMoveDrawerState();
  const { closeMenu: closeGlobalSideMenu, isOpen: globalSideMenuOpen } = (0,ex_web_packages.useSideMenuContext)();
  (0,react.useEffect)(() => {
    if (globalSideMenuOpen) {
      receiveDrawerState.closeMenu();
      moveDrawerState.closeMenu();
    }
  }, [globalSideMenuOpen, moveDrawerState, receiveDrawerState]);
  const inventoryTableFilterState = useInventoryTableFilterState();
  const moveForm = useMoveForm();
  return /* @__PURE__ */ react.createElement(InventoryContext.Provider, {
    value: {
      receiveDrawerState: {
        ...receiveDrawerState,
        openMenu: () => {
          closeGlobalSideMenu();
          moveDrawerState.closeMenu();
          receiveDrawerState.openMenu();
        }
      },
      moveDrawerState: {
        ...moveDrawerState,
        openMenu: () => {
          closeGlobalSideMenu();
          receiveDrawerState.closeMenu();
          moveDrawerState.openMenu();
        }
      },
      moveForm,
      inventoryTableFilterState
    }
  }, children);
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/InventoryActionButton.tsx












const useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  whiteText: {
    color: theme.palette.common.white
  },
  buttons: {
    color: theme.palette.common.white,
    width: "100%",
    display: "flex",
    justifyContent: "flex-end"
  },
  icon: { marginRight: "10px", fill: theme.palette.secondary.main },
  menuItem: { padding: "15px 25px" },
  menuSubtitle: {
    padding: "10px 20px 3px 20px",
    color: theme.palette.grey[600],
    fontWeight: "bold"
  },
  paper: { top: "54px!important", minWidth: "150px" }
}));
const InventoryActionButton = ({ locationId }) => {
  const classes = useStyles();
  const { roleName } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const [anchorEl, setAnchorEl] = react.useState(null);
  const { openMenu: openReceiveDrawer } = useReceiveDrawerContext();
  const { openMenu: openMoveDrawer } = useMoveDrawerContext();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /* @__PURE__ */ react.createElement("div", {
    className: classes.buttons
  }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.ChevronDownIcon, {
      className: classes.whiteText
    }),
    "aria-controls": "inventory-action-button",
    "aria-haspopup": "true",
    onClick: handleClick
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.header.button.actions",
    defaultMessage: "Actions"
  })), /* @__PURE__ */ react.createElement(Menu/* default */.Z, {
    id: "inventory-action-button",
    anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose,
    PopoverClasses: { paper: classes.paper }
  }, (0,permissions/* hasUpdateLotPermissions */.bn)(roleName) && /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    onClick: () => {
      handleClose();
      openMoveDrawer();
    },
    className: classes.menuItem
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.MoveIcon, {
    className: classes.icon
  }), /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.actions.move",
    defaultMessage: "Move"
  })), /* @__PURE__ */ react.createElement(Divider/* default */.Z, null), /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    onClick: () => {
      handleClose();
      openReceiveDrawer();
    },
    "data-testid": "receiveDrawerTriggerButton",
    className: classes.menuItem
  }, /* @__PURE__ */ react.createElement(LocalShipping/* default */.Z, {
    className: classes.icon
  }), /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.actions.receive",
    defaultMessage: "Receive"
  }))), (0,permissions/* hasMakeInventoryRequestPermission */.xv)(roleName) && /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Divider/* default */.Z, null), /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    component: react_router_dom_dist/* Link */.rU,
    to: (0,links/* linkToInventoryMoveRequests */.AC)(),
    onClick: handleClose,
    className: classes.menuItem
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.StockRequestsIcon, {
    className: classes.icon
  }), /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.actions.requests",
    defaultMessage: "Requests"
  }))), [role_definitions_dist_module/* Role.PHARMACIST */.uU.PHARMACIST, role_definitions_dist_module/* Role.DISPENSER */.uU.DISPENSER].includes(roleName) && /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Divider/* default */.Z, null), /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    className: classes.menuSubtitle
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.actions.subtitle.stockTake",
    defaultMessage: "Stocktake"
  }))), [role_definitions_dist_module/* Role.PHARMACIST */.uU.PHARMACIST].includes(roleName) && /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    component: react_router_dom_dist/* Link */.rU,
    to: (0,links/* linkToInitiateStockTake */.EN)(locationId),
    onClick: handleClose,
    className: classes.menuItem
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.StockTakeIcon, {
    className: classes.icon
  }), /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.actions.stockTake",
    defaultMessage: "Start Stocktake"
  })), /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    component: react_router_dom_dist/* Link */.rU,
    to: (0,links/* linkToStockTakeHistory */.fd)(),
    onClick: () => {
      handleClose();
    },
    className: classes.menuItem
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.HistoryIcon, {
    className: classes.icon
  }), /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.actions.stocktakeHistory",
    defaultMessage: "Stocktake History"
  }))), [role_definitions_dist_module/* Role.CLINIC */.uU.CLINIC, role_definitions_dist_module/* Role.PHARMACIST */.uU.PHARMACIST].includes(roleName) && /* @__PURE__ */ react.createElement("div", null, /* @__PURE__ */ react.createElement(Divider/* default */.Z, null), /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    component: react_router_dom_dist/* Link */.rU,
    to: (0,links/* linkToInventoryAudit */.qA)(),
    onClick: handleClose,
    className: classes.menuItem,
    "data-testid": "inventoryAuditMenuItem"
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.HistoryIcon, {
    className: classes.icon
  }), /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.actions.audit",
    defaultMessage: "Audit"
  })))));
};
/* harmony default export */ const inventory_overview_InventoryActionButton = (InventoryActionButton);

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/InventoryManagementHeader.tsx




const InventoryManagementHeader = () => {
  const { locationId } = useInventoryTableFilterContext();
  return /* @__PURE__ */ react.createElement(components/* InventoryHeader */.ae, {
    rightContent: /* @__PURE__ */ react.createElement(inventory_overview_InventoryActionButton, {
      locationId
    })
  });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.8.36/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(4548);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var mui_toast_dist = __webpack_require__(28841);
var mui_toast_dist_default = /*#__PURE__*/__webpack_require__.n(mui_toast_dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+react-hook-form-input@0.1.7_sjfm3rrfwwtsx5okgtvvldeidu/node_modules/@elephant-healthcare/react-hook-form-input/dist/module.js
var react_hook_form_input_dist_module = __webpack_require__(29054);
// EXTERNAL MODULE: ./src/client/inventory/form-components/RHFTextField.tsx
var RHFTextField = __webpack_require__(93004);
// EXTERNAL MODULE: ./src/client/inventory/form-components/TextField.tsx
var TextField = __webpack_require__(25262);
// EXTERNAL MODULE: ./src/client/inventory/components/LocationSelect/index.ts + 2 modules
var LocationSelect = __webpack_require__(93240);
;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/ReceiveDrawer/useReceiveValidationSchema.ts



const MAX_INT_SIZE = 2147483647;
const useReceiveValidationSchema = () => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const MAX_INT_SIZE_VALIDATION = es.number().integer(
    formatMessage({
      id: "inventory.form.receive.integerInput.error.notAnInt",
      defaultMessage: "Must be a whole number"
    })
  ).min(
    1,
    formatMessage({
      id: "inventory.form.receive.integerInput.error.minimum",
      defaultMessage: "Must be greater than 0"
    })
  ).max(
    MAX_INT_SIZE,
    formatMessage(
      {
        id: "inventory.form.receive.integerInput.error.maximum",
        defaultMessage: "Must be less than {maxSize}"
      },
      { maxSize: MAX_INT_SIZE }
    )
  );
  const SELECT_ITEM_VALIDATION = es.object({
    id: es.string().required(),
    name: es.string().required()
  }).required();
  return (0,react.useMemo)(() => {
    return es.object({
      supplier: SELECT_ITEM_VALIDATION,
      sku: SELECT_ITEM_VALIDATION,
      quantity: MAX_INT_SIZE_VALIDATION,
      expiryDate: es.date().required(),
      quantityPackSize: MAX_INT_SIZE_VALIDATION,
      quantityPacks: MAX_INT_SIZE_VALIDATION,
      locationId: es.string().required()
    });
  }, [formatMessage]);
};

// EXTERNAL MODULE: ./src/client/inventory/components/SkuSearchInput.tsx
var SkuSearchInput = __webpack_require__(34010);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(79226);
;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/queries.ts


const INVENTORY_SEARCH_QUERY = lib/* gql */.Ps`
  query inventoryLots(
    $name: String
    $facilityId: String!
    $locationId: String
    $orderBy: InventorySearchOrderProperty
    $orderDirection: OrderDirection
    $pageSize: Int
    $pageNumber: Int
  ) {
    inventorySearchTmp(
      input: {
        name: $name
        facilityId: $facilityId
        locationId: $locationId
        lot: { quantity: { value: 0, comparator: GT } }
        quantity: { value: 0, comparator: GT }
      }
      options: {
        order: { by: $orderBy, direction: $orderDirection }
        pageSize: $pageSize
        pageNumber: $pageNumber
      }
    ) {
      totalCount
      edges {
        node {
          id
          name
          quantity
          expiryDate
          supplyLevel
        }
      }
    }
  }
`;
const GET_LOTS_BY_SKU_ID_QUERY = lib/* gql */.Ps`
  query getLotsBySkuIdQuery($skuId: String!, $facilityId: String!, $locationId: String) {
    getLotsBySkuId(
      input: {
        skuId: $skuId
        facilityId: $facilityId
        locationId: $locationId
        quantity: { value: 0, comparator: GT }
      }
    ) {
      id
      locationId
      quantity
      expiryDate
    }
  }
`;
async function getLotBySkuId(client, { skuId, facilityId, locationId = null }) {
  return client.query({
    query: GET_LOTS_BY_SKU_ID_QUERY,
    variables: { skuId, facilityId, locationId }
  });
}
async function resetTableCache(client, args) {
  return client.refetchQueries({
    updateCache(cache) {
      cache.evict({ fieldName: "inventorySearchTmp" });
      if ("clearLotsForAllSkus" in args) {
        if (args.clearLotsForAllSkus) {
          cache.evict({
            fieldName: "getLotsBySkuId"
          });
        }
        return;
      }
      const { facilityId, skuIdToClearChildLotsFor, locationId = null } = args;
      const getLotBySkuArgs = {
        skuId: skuIdToClearChildLotsFor,
        facilityId,
        locationId,
        quantity: { value: 0, comparator: "GT" }
      };
      cache.evict({
        fieldName: "getLotsBySkuId",
        args: {
          input: getLotBySkuArgs
        }
      });
      if (locationId) {
        cache.evict({
          fieldName: "getLotsBySkuId",
          args: {
            input: { ...getLotBySkuArgs, locationId: null }
          }
        });
      }
    }
  });
}
function useResetTableCache() {
  const client = (0,useApolloClient/* useApolloClient */.x)();
  const { incrementRefreshKey } = useInventoryTableFilterContext();
  return async (args) => {
    const output = await resetTableCache(client, args);
    incrementRefreshKey();
    return output;
  };
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/ReceiveDrawer/ReceiveForm.tsx


















const SUPPLIER_LIST = lib/* gql */.Ps`
  query supplierReadAll {
    supplierReadAll {
      id
      name
    }
  }
`;
const CREATE_LOT_MUTATION = lib/* gql */.Ps`
  mutation createLot($input: ReceiveStockInput!) {
    receiveStock(input: $input) {
      expiryDate
      facilityId
      locationId
      id
      quantity
      skuId
    }
  }
`;
const ReceiveForm_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  form: {
    marginTop: theme.spacing(2)
  },
  button: {
    float: "right"
  },
  root: {
    "& $element": {
      color: theme.palette.primary.contrastText
    }
  },
  link: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  }
}));
const allDefined = (items) => items.every((item) => !!item);
function ReceiveForm() {
  var _a, _b;
  const { facilityId } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const inventoryTableFilterState = useInventoryTableFilterContext();
  const {
    setLoading,
    locationId: defaultLocationId,
    reset: resetInventoryOverviewState,
    defaultInventorySortBy
  } = inventoryTableFilterState;
  const validationSchema = useReceiveValidationSchema();
  const formMethods = (0,index_esm/* useForm */.cI)({
    defaultValues: { locationId: defaultLocationId, expiryDate: null },
    resolver: (0,yup/* yupResolver */.X)(validationSchema),
    mode: "onChange"
  });
  const { handleSubmit, watch, reset, setValue } = formMethods;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const resetTableCache = useResetTableCache();
  const [submit, { loading: submittedLoading }] = (0,useMutation/* useMutation */.D)(CREATE_LOT_MUTATION);
  const locationId = watch("locationId");
  const supplier = watch("supplier");
  const sku = watch("sku");
  const onSubmitReceive = async (form) => {
    try {
      setLoading(true);
      await submit({
        variables: {
          input: {
            supplierId: form.supplier.id,
            skuId: form.sku.id,
            quantity: form.quantityPackSize * form.quantityPacks,
            expiryDate: dayjs_min_default()(form.expiryDate).endOf("month").format("YYYY-MM-DD"),
            facilityId,
            locationId: form.locationId
          }
        }
      });
      mui_toast_dist_default().success(
        formatMessage({
          id: "inventory.form.receive.submit.success",
          defaultMessage: "Item successfully added."
        })
      );
      reset({
        supplier: form.supplier,
        locationId: form.locationId
      });
      const nextLocation = form.locationId === inventoryTableFilterState.locationId ? form.locationId : null;
      resetTableCache({
        skuIdToClearChildLotsFor: sku.id,
        facilityId,
        locationId: nextLocation
      });
      resetInventoryOverviewState({
        searchTerm: "",
        sortBy: defaultInventorySortBy,
        locationId: nextLocation
      });
    } catch (e) {
      mui_toast_dist_default().error(
        formatMessage({
          id: "inventory.form.receive.submit.error",
          defaultMessage: "Something went wrong while submitting receive data."
        })
      );
    }
  };
  const quantityPacks = (_a = watch("quantityPacks")) != null ? _a : 0;
  const quantitySize = (_b = watch("quantityPackSize")) != null ? _b : 0;
  const total = quantityPacks * quantitySize;
  const { loading: suppliersLoading, data: suppliersData } = (0,useQuery/* useQuery */.a)(SUPPLIER_LIST);
  (0,react.useEffect)(() => {
    var _a2;
    if (((_a2 = suppliersData == null ? void 0 : suppliersData.supplierReadAll) == null ? void 0 : _a2.length) === 1) {
      setValue("supplier", suppliersData.supplierReadAll[0]);
    }
  }, [setValue, suppliersData]);
  const classes = ReceiveForm_useStyles();
  return /* @__PURE__ */ react.createElement("form", {
    onSubmit: handleSubmit(onSubmitReceive),
    className: classes.form
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement(LocationSelect/* RHFLocationSelect */.N7, {
    id: "receive-location-select",
    label: formatMessage({
      id: "inventory.form.receive.location.label",
      defaultMessage: "Location"
    })
  }), /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* Autocomplete */.F2, {
    id: "supplier-search",
    name: "supplier",
    "data-testid": "supplier-search",
    fullWidth: true,
    loading: suppliersLoading,
    options: (suppliersData == null ? void 0 : suppliersData.supplierReadAll) || [],
    getOptionLabel: (option) => option.name,
    forcePopupIcon: false,
    freeSolo: true,
    renderInput: (errStr) => (params) => /* @__PURE__ */ react.createElement(TextField/* TextField */.n, {
      ...params,
      label: formatMessage({
        id: "inventory.form.receive.supplierSearch.label",
        defaultMessage: "Supplier"
      }),
      variant: "outlined",
      InputProps: {
        ...params.InputProps,
        type: "search"
      },
      error: errStr,
      required: true
    })
  }), /* @__PURE__ */ react.createElement(SkuSearchInput/* default */.Z, {
    name: "sku",
    analyticsEventName: "inventory_management.receiveForm.skuSearch",
    required: true
  }), allDefined([locationId, supplier, sku]) && /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    md: 6
  }, /* @__PURE__ */ react.createElement(RHFTextField/* RHFTextField */.a, {
    name: "quantityPackSize",
    type: "number",
    label: formatMessage({
      id: "inventory.form.receive.quantityPackSize.label",
      defaultMessage: "No of units in pack"
    }),
    "data-testid": "units-in-pack-field",
    variant: "outlined",
    inputProps: {
      min: 1,
      max: 2147483647
    },
    fullWidth: true,
    required: true
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    md: 6
  }, /* @__PURE__ */ react.createElement(RHFTextField/* RHFTextField */.a, {
    name: "quantityPacks",
    type: "number",
    label: formatMessage({
      id: "inventory.form.receive.quantityPacks.label",
      defaultMessage: "No of packs"
    }),
    "data-testid": "number-of-packs-field",
    variant: "outlined",
    inputProps: {
      min: 1,
      max: 2147483647
    },
    fullWidth: true,
    required: true
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    md: 6
  }, /* @__PURE__ */ react.createElement(RHFTextField/* RHFTextField */.a, {
    name: "totalUnits",
    value: total,
    disabled: true,
    label: formatMessage({
      id: "inventory.form.receive.totalUnits.label",
      defaultMessage: "Dispensible Units"
    }),
    "data-testid": "total-units-field",
    variant: "outlined",
    inputProps: {
      min: 0,
      max: 2147483647
    },
    fullWidth: true
  }))), allDefined([locationId, supplier, sku, total]) && /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* DatePicker */.Mt, {
    name: "expiryDate",
    label: formatMessage({
      id: "inventory.form.receive.expiryDate.label",
      defaultMessage: "Expiry Date"
    }),
    views: ["year", "month"],
    fullWidth: true,
    required: true,
    disablePast: true,
    format: "MM/yyyy"
  }), allDefined([locationId, supplier, sku, total]) && /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    type: "submit",
    color: "primary",
    variant: "contained",
    className: classes.button,
    loading: submittedLoading,
    "data-testid": "receive-submit-button",
    disabled: !formMethods.formState.isValid
  }, formatMessage({
    id: "inventory.form.receive.submitButton",
    defaultMessage: "Receive Item"
  }))));
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/SideDrawer.tsx




const styles = (0,makeStyles/* default */.Z)((theme) => ({
  container: {
    width: "100%",
    height: "auto",
    position: "fixed",
    zIndex: 35,
    top: 0,
    bottom: 0,
    left: "-35%",
    overflow: "auto",
    boxSizing: "border-box",
    transition: "left 0.15s ease-in",
    [theme.breakpoints.down("md")]: {
      left: "-45%"
    },
    [theme.breakpoints.down("sm")]: {
      left: "-100%"
    },
    [theme.breakpoints.up("md")]: {
      borderRight: `1px solid ${theme.palette.grey[300]}`
    }
  },
  formContainer: {
    padding: theme.spacing(3)
  },
  flexRowSeperated: {
    display: "flex",
    justifyContent: "space-between"
  },
  showMenu: {
    transition: "left 300ms ease-out",
    left: 0,
    background: theme.palette.common.white,
    paddingTop: "65px",
    zIndex: 29
  }
}));
function SideDrawer({
  isOpen,
  closeDrawer,
  children,
  title,
  ...props
}) {
  const classes = styles();
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    item: true,
    xs: 12,
    md: 5,
    lg: 4,
    className: `${classes.container} ${isOpen && classes.showMenu}`,
    "data-testid": props["drawerData-testId"]
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    className: `${classes.formContainer}`
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h2",
    className: classes.flexRowSeperated
  }, title, /* @__PURE__ */ react.createElement(dist_module/* IconButton */.hU, {
    "aria-label": "cancel",
    color: "primary",
    onClick: closeDrawer,
    "data-testid": props["closeIconData-testId"]
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.CloseIcon, null))), isOpen && children));
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/ReceiveDrawer/ReceiveDrawer.tsx





function ReceiveDrawer() {
  const { isOpen, closeMenu } = useReceiveDrawerContext();
  return /* @__PURE__ */ react.createElement(SideDrawer, {
    isOpen,
    closeDrawer: closeMenu,
    title: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "inventory.receiveDrawer.title",
      defaultMessage: "Receive"
    }),
    "drawerData-testId": "receiveDrawerContainer",
    "closeIconData-testId": "receiveDrawerCloseIcon"
  }, /* @__PURE__ */ react.createElement(ReceiveForm, null));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-card@0.2.10_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@elephant-healthcare/mui-card/dist/module.js
var mui_card_dist_module = __webpack_require__(21534);
;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/MoveDrawer/MoveLotCard.tsx








const MoveLotCard_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  titleRow: {
    marginBottom: theme.spacing(2)
  },
  grayText: {
    color: theme.palette.grey[700],
    minWidth: 65,
    marginBottom: theme.spacing(1)
  }
}));
function MoveLotCard({
  lotId,
  quantityInputName,
  lotName,
  locationName,
  expiryDate,
  currentLotQuantity,
  locationError,
  onRemoveClick
}) {
  const classes = MoveLotCard_useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */ react.createElement(mui_card_dist_module/* Card */.Zb, {
    "data-testid": `move-lot-card-${lotId}`
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    className: classes.titleRow
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, null, lotName), /* @__PURE__ */ react.createElement(dist_module/* IconButton */.hU, {
    "aria-label": "remove item",
    color: "primary",
    onClick: onRemoveClick
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.CloseIcon, {
    style: { fontSize: "1rem" }
  }))), /* @__PURE__ */ react.createElement(Box/* default */.Z, null, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 7
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    className: classes.grayText
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.move.lotCard.quantity",
    defaultMessage: "Location"
  })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, locationName)), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    className: classes.grayText
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.move.lotCard.expiry",
    defaultMessage: "Expiry"
  })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, dayjs_min_default()(expiryDate, "YYYY-MM-DD").format("MM / YYYY"))), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2",
    className: classes.grayText
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.move.lotCard.currentQuantity",
    defaultMessage: "Qty"
  })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, currentLotQuantity))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 5
  }, /* @__PURE__ */ react.createElement(RHFTextField/* RHFTextField */.a, {
    label: formatMessage({
      id: "inventory.move.lotCard.quantityToMove.label",
      defaultMessage: "Qty to Move"
    }),
    name: quantityInputName,
    type: "number"
  })))), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "caption",
    color: "error"
  }, locationError));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+lab@4.0.0-alpha.61_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/lab/esm/Alert/Alert.js + 4 modules
var Alert = __webpack_require__(10119);
;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/MoveDrawer/FormErrorAlert.tsx




function FormErrorAlert({ marginBottom }) {
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    marginBottom
  }, /* @__PURE__ */ react.createElement(Alert/* default */.Z, {
    severity: "error"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body2"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "formErrorAlert.defaultMessage",
    defaultMessage: "Something went wrong, please try again. If the problem persists please contact support."
  }))));
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/MoveDrawer/MoveForm.tsx














const MOVE_LOTS = lib/* gql */.Ps`
  mutation moveLots($input: MoveLotsInput!) {
    moveLots(input: $input) {
      moves {
        updatedSourceLot {
          expiryDate
          facilityId
          locationId
          id
          quantity
          skuId
        }
        updatedDestinationLot {
          expiryDate
          facilityId
          locationId
          id
          quantity
          skuId
        }
        quantityRequested
        quantityDecremented
        newDestinationLotCreated
      }
    }
  }
`;
function MoveForm() {
  const { form, sourceLotFields, removeLot } = useMoveFormContext();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { facilityId } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const resetTableCache = useResetTableCache();
  const { errors } = form.formState;
  const [moveLots, { error: moveLotError }] = (0,useMutation/* useMutation */.D)(MOVE_LOTS, {
    onCompleted: async () => {
      mui_toast_dist_default().success(
        formatMessage({
          id: "inventory.move.submitSuccessMessage",
          defaultMessage: "Successfully moved lots"
        })
      );
      form.reset();
      await resetTableCache({
        facilityId,
        clearLotsForAllSkus: true
      });
    }
  });
  async function handleSubmit(formValues) {
    if (!formValues.moves) {
      mui_toast_dist_default().error(
        formatMessage({
          id: "inventory.move.error.noMovesSpecified",
          defaultMessage: "Please specify at least one move"
        })
      );
      return;
    }
    await moveLots({
      variables: {
        input: {
          facilityId,
          destinationLocationId: formValues.destinationLocationId,
          moves: formValues.moves.map(({ sourceLotId, quantityToMove }) => ({
            sourceLotId,
            quantity: quantityToMove
          }))
        }
      }
    });
  }
  return /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    marginTop: 2
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...form
  }, /* @__PURE__ */ react.createElement("form", {
    onSubmit: form.handleSubmit(handleSubmit)
  }, /* @__PURE__ */ react.createElement(index_esm/* Controller */.Qr, {
    control: form.control,
    name: "destinationLocationId",
    rules: { required: true },
    render: ({ field: { onChange, onBlur, value } }) => {
      var _a;
      return /* @__PURE__ */ react.createElement(LocationSelect/* LocationSelect */.AO, {
        ...{ onChange, onBlur, value },
        error: (_a = errors.destinationLocationId) == null ? void 0 : _a.message,
        id: "move-destination-location",
        label: formatMessage({
          id: "inventory.move.form.destinationLocation",
          defaultMessage: "Move To"
        })
      });
    }
  }), sourceLotFields.length === 0 ? /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginY: 4
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, null, /* @__PURE__ */ react.createElement("b", null, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.move.noLotsSelectedMessage",
    defaultMessage: "Please select medication lots"
  })))) : null, sourceLotFields.map(
    ({
      sourceLotId,
      locationName,
      name,
      expiryDate,
      currentLotQuantity
    }, index) => {
      var _a, _b, _c;
      return /* @__PURE__ */ react.createElement(MoveLotCard, {
        key: sourceLotId,
        lotId: sourceLotId,
        locationName,
        expiryDate,
        lotName: name,
        currentLotQuantity,
        quantityInputName: `moves.${index}.quantityToMove`,
        locationError: (_c = (_b = (_a = errors == null ? void 0 : errors.moves) == null ? void 0 : _a[index]) == null ? void 0 : _b.locationId) == null ? void 0 : _c.message,
        onRemoveClick: () => removeLot(index)
      });
    }
  ), moveLotError && /* @__PURE__ */ react.createElement(FormErrorAlert, {
    marginBottom: 2
  }), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: () => form.reset()
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.move.form.cancel",
    defaultMessage: "Cancel Move"
  })), /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* SubmitButton */.Mm, {
    size: "large",
    type: "submit",
    "data-testid": "move-submit-button",
    disabled: form.formState.isSubmitting,
    loading: form.formState.isSubmitting
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.move.form.sumbit",
    defaultMessage: "Move"
  }))))));
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/MoveDrawer/MoveDrawer.tsx





function MoveDrawer() {
  const { isOpen, closeMenu } = useMoveDrawerContext();
  return /* @__PURE__ */ react.createElement(SideDrawer, {
    isOpen,
    closeDrawer: closeMenu,
    title: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "inventory.moveDrawer.title",
      defaultMessage: "Move"
    }),
    "drawerData-testId": "moveDrawerContainer",
    "closeIconData-testId": "moveDrawerCloseIcon"
  }, /* @__PURE__ */ react.createElement(MoveForm, null));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/esm/Edit.js
var Edit = __webpack_require__(85031);
// EXTERNAL MODULE: ./src/client/inventory/components/SortBySelect.tsx
var SortBySelect = __webpack_require__(15054);
// EXTERNAL MODULE: ./src/client/inventory/components/ExpiryCell.tsx
var ExpiryCell = __webpack_require__(96425);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-input@0.3.5_atek3e5pugfjeukz7kzynbm6iy/node_modules/@elephant-healthcare/mui-input/dist/module.js
var mui_input_dist_module = __webpack_require__(34948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-modal@0.3.9_vyafebljftw2lpwbgyprbkkpkm/node_modules/@elephant-healthcare/mui-modal/dist/module.js
var mui_modal_dist_module = __webpack_require__(27832);
;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/EditLotModal/useReasonTypes.ts

function useReasonTypes() {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return [
    {
      label: formatMessage({
        id: "inventory.modal.editLot.field-reasonCategory-error",
        defaultMessage: "Error"
      }),
      value: "ERROR"
    },
    {
      label: formatMessage({
        id: "inventory.modal.editLot.field-reasonCategory-wastage",
        defaultMessage: "Wastage"
      }),
      value: "WASTAGE"
    },
    {
      label: formatMessage({
        id: "inventory.modal.editLot.field-reasonCategory-transferToAnotherFacility",
        defaultMessage: "Transfer to Other Facility"
      }),
      value: "TRANSFER_TO_ANOTHER_FACILITY"
    },
    {
      label: formatMessage({
        id: "inventory.modal.editLot.field-reasonCategory-expired",
        defaultMessage: "Expired"
      }),
      value: "EXPIRED"
    },
    {
      label: formatMessage({
        id: "inventory.modal.editLot.field-reasonCategory-other",
        defaultMessage: "Other"
      }),
      value: "OTHER"
    }
  ];
}
/* harmony default export */ const EditLotModal_useReasonTypes = (useReasonTypes);

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/EditLotModal/editLotFormValidation.ts


const useValidationSchema = () => {
  return (0,react.useMemo)(
    () => (0,es.object)({
      quantity: (0,es.number)().min(0).required(),
      expiryDate: (0,es.date)().required(),
      reasonCategory: (0,es.string)().required(),
      reasonText: (0,es.string)().when("reasonCategory", {
        is: "OTHER",
        then: (0,es.string)().required()
      })
    }),
    []
  );
};

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/EditLotModal/EditLotModal.tsx













const EditLotModal_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  icon: {
    color: theme.palette.secondary.main,
    marginRight: "10px"
  }
}));
function EditLotModal(props) {
  const classes = EditLotModal_useStyles();
  const { onClose, isOpen, lot, handleLotEditSubmit } = props;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const reasonTypes = EditLotModal_useReasonTypes();
  const validationSchema = useValidationSchema();
  const formMethods = (0,index_esm/* useForm */.cI)({
    mode: "onChange",
    reValidateMode: "onSubmit",
    resolver: (0,yup/* yupResolver */.X)(validationSchema)
  });
  (0,react.useEffect)(() => {
    const defaults = {
      id: lot == null ? void 0 : lot.id,
      quantity: lot == null ? void 0 : lot.quantity,
      expiryDate: lot == null ? void 0 : lot.expiryDate,
      reasonText: "",
      reasonCategory: null
    };
    formMethods.reset(defaults);
  }, [lot, formMethods.reset]);
  if (!isOpen) {
    return null;
  }
  const quantityField = formMethods.watch("quantity");
  const expiryField = formMethods.watch("expiryDate");
  const reasonCategory = formMethods.watch("reasonCategory");
  const hasChangedLotData = quantityField !== (lot == null ? void 0 : lot.quantity) || expiryField !== (lot == null ? void 0 : lot.expiryDate);
  const isValid = formMethods.formState.isValid && hasChangedLotData;
  return /* @__PURE__ */ react.createElement(mui_modal_dist_module/* Modal */.u_, {
    open: isOpen,
    onClose,
    "data-testid": "edit-lot-modal"
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    "aria-label": "form",
    onSubmit: formMethods.handleSubmit(handleLotEditSubmit)
  }, /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalBody */.fe, {
    pb: 0
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    pb: 2,
    display: "flex",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.WarningIcon, {
    viewBox: "0 0 32 32",
    fontSize: "large",
    className: classes.icon
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h4",
    component: "h1"
  }, lot == null ? void 0 : lot.name)), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    pb: 1
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "caption"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.modal.editLot.field-quantityHelpText",
    defaultMessage: "Quantity or expiry date must changed to submit an update"
  })))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 4
  }, /* @__PURE__ */ react.createElement(RHFTextField/* RHFTextField */.a, {
    name: "quantity",
    label: formatMessage({
      id: "inventory.modal.editLot.field-quantity",
      defaultMessage: "Quantity"
    }),
    "data-testid": "lot-quantity-field",
    type: "number",
    required: true,
    style: { width: "100%" }
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 4
  }, /* @__PURE__ */ react.createElement(index_esm/* Controller */.Qr, {
    control: formMethods.control,
    name: "expiryDate",
    rules: { required: true },
    render: ({ field: { onChange, onBlur, value } }) => /* @__PURE__ */ react.createElement(mui_input_dist_module/* DatePicker */.Mt, {
      label: formatMessage({
        id: "inventory.modal.editLot.field-expiryDate",
        defaultMessage: "Expiry Date"
      }),
      "data-testid": "lot-expiryDate-field",
      views: ["year", "month"],
      disablePast: true,
      format: "MM / yyyy",
      onChange,
      onBlur,
      value,
      required: true
    })
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 4
  }, /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* SelectField */.mg, {
    name: "reasonCategory",
    label: formatMessage({
      id: "inventory.modal.editLot.field-reasonCategory",
      defaultMessage: "Type of change"
    }),
    options: reasonTypes,
    fullWidth: true,
    customWidth: "100%",
    required: true,
    selectProps: {
      "data-testid": "lot-reasonType-select"
    }
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12
  }, /* @__PURE__ */ react.createElement(RHFTextField/* RHFTextField */.a, {
    name: "reasonText",
    label: formatMessage({
      id: "inventory.modal.editLot.field-reason",
      defaultMessage: "Reason for change"
    }),
    "data-testid": "lot-reasonText-field",
    multiline: true,
    rows: 3,
    fullWidth: true,
    required: reasonCategory === "OTHER"
  })))), /* @__PURE__ */ react.createElement(mui_modal_dist_module/* ModalFooter */.mz, null, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "tertiary",
    onClick: onClose
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.modal.editLot.cancel",
    defaultMessage: "Cancel"
  })), /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* SubmitButton */.Mm, {
    disabled: !isValid,
    "data-testid": "edit-lot-submit-button"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.modal.editLot.submit",
    defaultMessage: "Update Lot"
  }))))));
}
/* harmony default export */ const EditLotModal_EditLotModal = (EditLotModal);

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/useUpdateLot.ts






const UPDATE_LOT_MUTATION = lib/* gql */.Ps`
  mutation updateLot(
    $id: ID!
    $facilityId: ID!
    $expiryDate: Date!
    $quantity: Int!
    $reasonForChange: ChangeReason!
    $reasonForChangeText: String
  ) {
    updateLot(
      input: {
        id: $id
        facilityId: $facilityId
        expiryDate: $expiryDate
        quantity: $quantity
        reasonForChange: $reasonForChange
        reasonForChangeText: $reasonForChangeText
      }
    ) {
      id
      quantity
      expiryDate
    }
  }
`;
function useUpdateLot({
  selectedLotSkuId,
  facilityId,
  inventoryTableFilterState: { locationId },
  onUpdateSuccess
}) {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const resetTableCache = useResetTableCache();
  const [updateLot] = (0,useMutation/* useMutation */.D)(UPDATE_LOT_MUTATION, {
    onError(err) {
      const uniqueContstraintError = err.message.match(
        /Unique constraint failed on the fields/g
      ).length;
      mui_toast_dist_default().error(
        uniqueContstraintError ? formatMessage({
          id: "inventory.overview.updateLotError.expiryDateUniqueConstraint",
          defaultMessage: "Cannot update: A lot with this expiry date already exists"
        }) : formatMessage({
          id: "inventory.overview.updateLotError",
          defaultMessage: "Something went wrong while updating the lot"
        }),
        { duration: 5e3 }
      );
    },
    onCompleted() {
      mui_toast_dist_default().success(
        formatMessage({
          id: "inventory.overview.updateLotSuccess",
          defaultMessage: "Successfully updated the lot"
        })
      );
      onUpdateSuccess();
      resetTableCache({
        facilityId,
        skuIdToClearChildLotsFor: selectedLotSkuId,
        locationId
      });
    }
  });
  return (0,react.useCallback)(
    async (data) => {
      updateLot({
        variables: {
          id: data.id,
          quantity: data.quantity,
          expiryDate: dayjs_min_default()(data.expiryDate).endOf("month").format("YYYY-MM-DD"),
          reasonForChange: data.reasonCategory,
          reasonForChangeText: data.reasonText || null,
          facilityId
        }
      });
    },
    [updateLot, facilityId]
  );
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(50062);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(90322);
// EXTERNAL MODULE: ./node_modules/.pnpm/use-debounce@8.0.4_react@18.1.0/node_modules/use-debounce/dist/index.module.js
var index_module = __webpack_require__(53890);
// EXTERNAL MODULE: ./src/client/inventory/hooks/useFacilityLocations.tsx + 1 modules
var useFacilityLocations = __webpack_require__(62174);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(91241);
;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/MoveDrawer/MoveLotCheckbox.tsx



const MoveLotCheckbox_useStyles = (0,makeStyles/* default */.Z)({
  checkbox: {
    padding: 0
  }
});
function MoveLotCheckbox({
  lotId,
  name,
  locationId,
  locationName,
  expiryDate,
  quantity,
  ...props
}) {
  const { showCheckboxes } = useMoveDrawerContext();
  const { isLotSelected, handleLotClick } = useMoveFormContext();
  const classes = MoveLotCheckbox_useStyles();
  return showCheckboxes ? /* @__PURE__ */ react.createElement(Checkbox/* default */.Z, {
    className: classes.checkbox,
    inputProps: {
      "data-testid": props["data-testid"] || "move-lots-checkbox"
    },
    checked: isLotSelected(lotId),
    onChange: () => handleLotClick({
      key: lotId,
      sourceLotId: lotId,
      name,
      locationId,
      locationName,
      expiryDate,
      currentLotQuantity: quantity
    })
  }) : null;
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/useSearchLots.tsx








function isCacheAndNetworkLoading({
  data,
  networkStatus
}) {
  return networkStatus < 7 && !data || networkStatus === core_networkStatus/* NetworkStatus.refetch */.I.refetch;
}
function useGroupLots({
  facilityId,
  locationId,
  ungroupedData,
  refreshKey
}) {
  const client = (0,useApolloClient/* useApolloClient */.x)();
  const { data: locationsData } = (0,useFacilityLocations/* useFacilityLocations */.bx)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const getRowChildren = async ({ skuId, name }) => {
    const { data, error } = await getLotBySkuId(client, {
      skuId,
      facilityId,
      locationId
    });
    if (error) {
      mui_toast_dist_default().error(
        formatMessage({
          id: "inventory.overview.fetchChildrenError",
          defaultMessage: "Something went wrong while fetching lots"
        })
      );
      return [];
    }
    return data.getLotsBySkuId.map((lot) => {
      const location = locationsData == null ? void 0 : locationsData.find(({ _id }) => _id === lot.locationId);
      return {
        ...lot,
        name,
        location: location == null ? void 0 : location.name,
        skuId,
        __expander: /* @__PURE__ */ react.createElement(MoveLotCheckbox, {
          lotId: lot.id,
          name,
          locationId: lot.locationId,
          locationName: location == null ? void 0 : location.name,
          expiryDate: lot.expiryDate.toString(),
          quantity: lot.quantity
        })
      };
    });
  };
  const groupLots = (updatingRefreshKey, inventoryData) => {
    var _a, _b;
    return ((_b = (_a = inventoryData == null ? void 0 : inventoryData.inventorySearchTmp) == null ? void 0 : _a.edges) != null ? _b : []).map(
      (inventorySummaryEdge) => ({
        ...inventorySummaryEdge.node,
        skuId: inventorySummaryEdge.node.id,
        meta: {
          isExpanding: true,
          fetchKey: `${inventorySummaryEdge.node.id}${updatingRefreshKey && `|${updatingRefreshKey}`}`,
          fetchChildren: (sku) => getRowChildren({
            skuId: sku.skuId,
            name: inventorySummaryEdge.node.name
          })
        }
      })
    );
  };
  const groupedLots = (0,react.useMemo)(() => {
    return ungroupedData ? groupLots(refreshKey, ungroupedData) : [];
  }, [
    ungroupedData,
    locationId,
    refreshKey
  ]);
  return groupedLots;
}
function useSearchLots({
  inventoryTableFilterState: {
    locationId,
    defaultInventorySortBy,
    searchTerm,
    sortBy,
    refreshKey
  },
  facilityId,
  currentPage,
  pageSize
}) {
  const [searchLots, { data: ungroupedData, error, networkStatus }] = (0,useLazyQuery/* useLazyQuery */.t)(INVENTORY_SEARCH_QUERY, {
    fetchPolicy: "cache-and-network"
  });
  const [debouncedSearchTerm] = (0,index_module/* useDebounce */.Nr)(searchTerm, 300);
  (0,react.useEffect)(() => {
    var _a;
    if (facilityId) {
      searchLots({
        variables: {
          name: debouncedSearchTerm,
          facilityId,
          locationId,
          orderBy: (_a = sortBy == null ? void 0 : sortBy.field) != null ? _a : defaultInventorySortBy == null ? void 0 : defaultInventorySortBy.field,
          orderDirection: sortBy == null ? void 0 : sortBy.direction,
          pageNumber: currentPage,
          pageSize
        }
      });
    }
  }, [
    debouncedSearchTerm,
    facilityId,
    locationId,
    searchLots,
    sortBy,
    defaultInventorySortBy,
    currentPage,
    pageSize
  ]);
  const [totalRows, setTotalRows] = (0,react.useState)(0);
  (0,react.useMemo)(() => {
    setTotalRows((prevState) => {
      var _a, _b;
      return ((_a = ungroupedData == null ? void 0 : ungroupedData.inventorySearchTmp) == null ? void 0 : _a.totalCount) === null || ((_b = ungroupedData == null ? void 0 : ungroupedData.inventorySearchTmp) == null ? void 0 : _b.totalCount) === void 0 ? prevState : ungroupedData.inventorySearchTmp.totalCount;
    });
  }, [ungroupedData, setTotalRows]);
  const groupedLots = useGroupLots({
    facilityId,
    locationId,
    refreshKey,
    ungroupedData
  });
  return {
    data: groupedLots,
    totalRows,
    loading: isCacheAndNetworkLoading({
      data: ungroupedData,
      networkStatus
    }),
    error
  };
}

// EXTERNAL MODULE: ./src/client/components/ErrorPage/index.tsx
var ErrorPage = __webpack_require__(64493);
// EXTERNAL MODULE: ./src/client/components/SearchBar/index.ts + 1 modules
var SearchBar = __webpack_require__(67753);
;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/InventoryOverview.tsx


















const PAGE_SIZE = 20;
const InventoryOverview_styles = (0,makeStyles/* default */.Z)((theme) => ({
  headerControls: {
    marginBottom: theme.spacing(3)
  },
  inheritFontWeight: {
    fontWeight: "inherit"
  },
  reducePadding: {
    padding: "0 10px"
  }
}));
function getTableColumns({
  handleEditClick,
  formatMessage,
  roleName
}) {
  const fields = [
    {
      field: "name",
      headerName: formatMessage({
        id: "inventory.overview.table.columnLabel.name",
        defaultMessage: "MEDICATION"
      }),
      flex: 8
    },
    {
      field: "location",
      headerName: "",
      flex: 2
    },
    {
      field: "quantity",
      headerName: formatMessage({
        id: "inventory.overview.table.columnLabel.quantity",
        defaultMessage: "UNITS"
      }),
      flex: 1,
      alignContents: "right"
    },
    {
      field: "expiryDate",
      headerName: formatMessage({
        id: "inventory.overview.table.columnLabel.expiryDate",
        defaultMessage: "EXPIRY DATE"
      }),
      width: 125,
      alignContents: "right",
      renderCell: (value) => /* @__PURE__ */ react.createElement(ExpiryCell/* default */.Z, {
        expiryDate: value
      })
    },
    (0,permissions/* hasUpdateLotPermissions */.bn)(roleName) && {
      field: "actions",
      width: 55,
      padding: "0 10px",
      alignContents: "right",
      hideContentsforGroupHeader: true,
      renderCell: (_, _index, _column, row) => /* @__PURE__ */ react.createElement(dist_module/* IconButton */.hU, {
        "aria-label": "edit",
        "aria-controls": "edit",
        onClick: () => {
          handleEditClick(row);
        }
      }, /* @__PURE__ */ react.createElement(Edit/* default */.Z, null))
    }
  ];
  return fields.filter(Boolean);
}
const InventoryOverview = ({
  pageSize = PAGE_SIZE
}) => {
  const classes = InventoryOverview_styles();
  const inventoryTableFilterState = useInventoryTableFilterContext();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { facilityId, roleName } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const [selectedLot, setSelectedLot] = (0,react.useState)(null);
  const [openModal, setOpenModal] = (0,react.useState)(false);
  const sortByOptions = inventory_overview_useSortByOptions();
  const [currentPage, setCurrentPage] = (0,react.useState)(0);
  const {
    loading,
    locationId,
    setLocationId,
    sortBy,
    setSortBy,
    searchTerm,
    setSearchTerm
  } = inventoryTableFilterState;
  function handleEditClick(lot) {
    setSelectedLot(lot);
    setOpenModal(true);
  }
  const handleLotEditSubmit = useUpdateLot({
    facilityId,
    selectedLotSkuId: selectedLot == null ? void 0 : selectedLot.skuId,
    inventoryTableFilterState,
    onUpdateSuccess: () => {
      setOpenModal(false);
      setSelectedLot(null);
    }
  });
  const tableColumns = getTableColumns({
    handleEditClick,
    formatMessage,
    roleName
  });
  const {
    data: groupedLots,
    totalRows,
    loading: lotsLoading,
    error: lotsError
  } = useSearchLots({
    inventoryTableFilterState,
    facilityId,
    currentPage,
    pageSize
  });
  if (lotsError)
    return /* @__PURE__ */ react.createElement(ErrorPage/* default */.Z, {
      error: lotsError
    });
  return /* @__PURE__ */ react.createElement("div", {
    "data-testid": "inventoryOverview"
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2,
    className: classes.headerControls,
    "data-testid": "inventoryOverviewControls"
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 3
  }, /* @__PURE__ */ react.createElement(LocationSelect/* LocationSelectWithAllOption */.es, {
    value: locationId,
    onChange: setLocationId
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 7
  }, /* @__PURE__ */ react.createElement(SearchBar/* default */.Z, {
    placeholderText: formatMessage({
      id: "inventory.overview.searchBar.placeholder",
      defaultMessage: "Search Inventory"
    }),
    value: searchTerm,
    onChange: setSearchTerm,
    onClear: () => setSearchTerm(""),
    dataTestId: "inventoryOverviewSearchBar"
  })), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 2
  }, /* @__PURE__ */ react.createElement(SortBySelect/* SortBySelect */.z, {
    options: Object.values(sortByOptions),
    value: sortBy,
    onChange: setSortBy
  }))), /* @__PURE__ */ react.createElement(ex_web_packages.Table, {
    loading: lotsLoading || loading,
    columns: tableColumns,
    rows: groupedLots != null ? groupedLots : [],
    noDataMessage: formatMessage({
      id: "inventory.overview.list.noData",
      defaultMessage: "No lots found for that search."
    }),
    expandingGroups: true,
    pagination: {
      page: currentPage,
      pageSize,
      totalRows,
      handlePageChange: (newPageNumber) => {
        setCurrentPage(newPageNumber);
      }
    }
  }), /* @__PURE__ */ react.createElement(EditLotModal_EditLotModal, {
    isOpen: openModal,
    onClose: () => setOpenModal(false),
    lot: selectedLot,
    handleLotEditSubmit
  }));
};
/* harmony default export */ const inventory_overview_InventoryOverview = ((/* unused pure expression or super */ null && (InventoryOverview)));

;// CONCATENATED MODULE: ./src/client/inventory/pages/inventory-overview/InventoryManagementPage.tsx









const InventoryManagementPage_styles = (0,makeStyles/* default */.Z)((theme) => ({
  animateWidth: {
    transition: "all 0.3s ease-in-out"
  },
  force0Width: {
    maxWidth: "0",
    flexBasis: "0"
  },
  body: {
    marginTop: theme.spacing(2)
  }
}));
const InventoryPage = (props) => {
  const { children } = props;
  const { isOpen: receiveDrawerOpen } = useReceiveDrawerContext();
  const { isOpen: moveDrawerOpen } = useMoveDrawerContext();
  const isOpen = receiveDrawerOpen || moveDrawerOpen;
  const classes = InventoryManagementPage_styles();
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    md: 5,
    lg: 4,
    className: `${classes.animateWidth} ${!isOpen && classes.force0Width}`
  }), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: isOpen ? false : 12,
    md: isOpen ? 7 : 12,
    lg: isOpen ? 8 : 12,
    className: `${classes.animateWidth} ${classes.body}`
  }, children));
};
const pageStyles = (0,makeStyles/* default */.Z)((theme) => ({
  reducedPadding: {
    padding: theme.spacing(1, 8)
  }
}));
const InventoryManagementPage = () => {
  const classes = pageStyles();
  return /* @__PURE__ */ react.createElement(ex_web_packages.LayoutWithSideMenu, null, /* @__PURE__ */ react.createElement(InventoryContextProvider, null, /* @__PURE__ */ react.createElement(InventoryManagementHeader, null), /* @__PURE__ */ react.createElement(ReceiveDrawer, null), /* @__PURE__ */ react.createElement(MoveDrawer, null), /* @__PURE__ */ react.createElement(dist.Page, {
    className: classes.reducedPadding
  }, /* @__PURE__ */ react.createElement(InventoryPage, null, /* @__PURE__ */ react.createElement(InventoryOverview, null)))));
};
/* harmony default export */ const inventory_overview_InventoryManagementPage = (InventoryManagementPage);


/***/ }),

/***/ 45216:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* reexport */ fulfilment_FulfillMoveRequest)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(77589);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-page@0.4.3_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-page/dist/index.js
var mui_page_dist = __webpack_require__(48534);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./src/ex-web-packages/index.ts
var ex_web_packages = __webpack_require__(26298);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+react-hook-form-input@0.1.7_sjfm3rrfwwtsx5okgtvvldeidu/node_modules/@elephant-healthcare/react-hook-form-input/dist/module.js
var react_hook_form_input_dist_module = __webpack_require__(29054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var user_context_provider_dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./src/client/inventory/routing/links.ts
var links = __webpack_require__(57706);
// EXTERNAL MODULE: ./src/client/inventory/components/LocationSelect/index.ts + 2 modules
var LocationSelect = __webpack_require__(93240);
// EXTERNAL MODULE: ./src/client/inventory/components/index.ts + 5 modules
var components = __webpack_require__(6944);
// EXTERNAL MODULE: ./src/client/inventory/formatting.ts
var formatting = __webpack_require__(41907);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/fulfilment/__generated__/queries.gql.ts


const defaultOptions = {};
const FulfillInventoryMoveRequestPageDocument = lib/* gql */.Ps`
    query fulfillInventoryMoveRequestPage($input: InventoryMoveRequestInput!, $lotsInput: InventoryMoveRequestSkusAvailableLotsInput!) {
  inventoryMoveRequest(input: $input) {
    id
    createdAt
    requestor {
      person {
        firstname
        lastname
      }
    }
    receivingLocation {
      name
    }
    skus {
      items {
        id
        quantityRequested
        sku {
          id
          name
        }
        availableLots(input: $lotsInput) {
          id
          quantity
          expiryDate
        }
      }
    }
  }
}
    `;
function useFulfillInventoryMoveRequestPageQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(FulfillInventoryMoveRequestPageDocument, options);
}
function useFulfillInventoryMoveRequestPageLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(FulfillInventoryMoveRequestPageDocument, options);
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/fulfilment/queries.ts


lib/* gql */.Ps`
  query fulfillInventoryMoveRequestPage(
    $input: InventoryMoveRequestInput!
    $lotsInput: InventoryMoveRequestSkusAvailableLotsInput!
  ) {
    inventoryMoveRequest(input: $input) {
      id
      createdAt
      requestor {
        person {
          firstname
          lastname
        }
      }
      receivingLocation {
        name
      }
      skus {
        items {
          id
          quantityRequested
          sku {
            id
            name
          }
          availableLots(input: $lotsInput) {
            id
            quantity
            expiryDate
          }
        }
      }
    }
  }
`;


// EXTERNAL MODULE: ./src/client/inventory/form-components/RHFTextField.tsx
var RHFTextField = __webpack_require__(93004);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-chip@0.1.9_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-chip/dist/module.js
var mui_chip_dist_module = __webpack_require__(85810);
// EXTERNAL MODULE: ./src/client/inventory/components/constants.tsx
var constants = __webpack_require__(39659);
// EXTERNAL MODULE: ./src/client/inventory/components/ExpiryCell.tsx
var ExpiryCell = __webpack_require__(96425);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/fulfilment/SkuQuantityToSendTotalChip.tsx



const SkuQuantityToSendTotalChip = ({
  requestSkuId,
  quantityRequested
}) => {
  const lotValuesForSku = (0,index_esm/* useWatch */.qo)({
    name: `skus.${requestSkuId}`
  });
  const totalBeingSentForSku = Object.values(lotValuesForSku || {}).reduce(
    (acc, curr) => acc + parseInt(curr.quantity || "0", 10),
    0
  );
  return /* @__PURE__ */ react.createElement(components/* FractionChip */.Xc, {
    numerator: totalBeingSentForSku,
    denominator: quantityRequested
  });
};
/* harmony default export */ const fulfilment_SkuQuantityToSendTotalChip = (SkuQuantityToSendTotalChip);

;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/fulfilment/FulfillMoveRequestTable.tsx








function mapFetchedDataToTableData({
  data = [],
  childrenFetched,
  notAvailableMessage
}) {
  return data.map((row) => {
    var _a, _b;
    const skuNotAvailableAtLocation = childrenFetched && row.availableLots.length === 0;
    return {
      header: {
        id: row.id,
        requestSkuId: row.id,
        skuName: (_a = row.sku) == null ? void 0 : _a.name,
        quantityRequested: row.quantityRequested,
        notAvailableAtLocation: skuNotAvailableAtLocation,
        quantityAvailable: skuNotAvailableAtLocation ? notAvailableMessage : void 0
      },
      children: (_b = row.availableLots) == null ? void 0 : _b.map((lot) => ({
        id: lot.id,
        requestSkuId: row.id,
        lotId: lot.id,
        quantityAvailable: lot.quantity,
        expiryDate: lot.expiryDate
      }))
    };
  });
}
const FulfillMoveRequestTable = ({
  loading,
  data,
  childrenFetched
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const columns = [
    {
      field: "skuName",
      headerName: formatMessage({
        id: "inventory.fulfillmoveRequest.table.columnLabel.skuName",
        defaultMessage: "Requested Item"
      }),
      flex: 3
    },
    {
      field: "quantityRequested",
      headerName: formatMessage({
        id: "inventory.fulfillmoveRequest.table.columnLabel.quantityRequested",
        defaultMessage: "Qty Requested"
      }),
      flex: 1,
      renderCell: (_value, _index, _column, row, { isParentRow }) => {
        if (!isParentRow) {
          return null;
        }
        if (!childrenFetched) {
          return /* @__PURE__ */ react.createElement(mui_chip_dist_module/* Chip */.A, {
            label: row.quantityRequested,
            color: constants/* chipColors.neutral */.y.neutral
          });
        }
        if (row.notAvailableAtLocation) {
          return /* @__PURE__ */ react.createElement(mui_chip_dist_module/* Chip */.A, {
            label: `0 / ${row.quantityRequested}`,
            color: constants/* chipColors.neutral */.y.neutral
          });
        }
        return /* @__PURE__ */ react.createElement(fulfilment_SkuQuantityToSendTotalChip, {
          requestSkuId: row.requestSkuId,
          quantityRequested: row.quantityRequested
        });
      }
    },
    {
      field: "expiryDate",
      headerName: formatMessage({
        id: "inventory.fulfillmoveRequest.table.columnLabel.expiryDate",
        defaultMessage: "Expiry Date"
      }),
      flex: 1,
      renderCell: (expiryDate) => expiryDate ? /* @__PURE__ */ react.createElement(ExpiryCell/* default */.Z, {
        expiryDate
      }) : ""
    },
    {
      field: "quantityAvailable",
      headerName: formatMessage({
        id: "inventory.fulfillmoveRequest.table.columnLabel.quantityAvailable",
        defaultMessage: "Qty Available"
      }),
      flex: 1
    },
    {
      field: "quantityToSend",
      headerName: formatMessage({
        id: "inventory.fulfillmoveRequest.table.columnLabel.quantityToSend",
        defaultMessage: "Qty To Send"
      }),
      flex: 1,
      renderCell: (_value, _index, _column, row, { isParentRow }) => {
        if (isParentRow) {
          return null;
        }
        return /* @__PURE__ */ react.createElement(RHFTextField/* RHFTextField */.a, {
          name: `skus.${row.requestSkuId}.${row.lotId}.quantity`,
          inputProps: { type: "number" },
          type: "number",
          hideHelper: true,
          hiddenLabel: true,
          size: "small",
          InputProps: {
            style: { width: "130px", height: "50px", margin: "-8px" }
          }
        });
      }
    }
  ];
  return /* @__PURE__ */ react.createElement(ex_web_packages.Table, {
    loading,
    columns,
    rows: mapFetchedDataToTableData({
      data,
      childrenFetched,
      notAvailableMessage: formatMessage({
        id: "inventory.fulfillmoveRequest.table.notAvailableAtLocation",
        defaultMessage: "Not available"
      })
    })
  });
};
/* harmony default export */ const fulfilment_FulfillMoveRequestTable = (FulfillMoveRequestTable);

// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var mui_toast_dist = __webpack_require__(28841);
var mui_toast_dist_default = /*#__PURE__*/__webpack_require__.n(mui_toast_dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/fulfilment/__generated__/useFulfillMoveRequestForm.gql.ts


const useFulfillMoveRequestForm_gql_defaultOptions = {};
const FulfillInventoryMoveRequestDocument = lib/* gql */.Ps`
    mutation fulfillInventoryMoveRequest($input: FulfillInventoryMoveRequestInput!) {
  fulfillInventoryMoveRequest(input: $input) {
    id
  }
}
    `;
function useFulfillInventoryMoveRequestMutation(baseOptions) {
  const options = { ...useFulfillMoveRequestForm_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(FulfillInventoryMoveRequestDocument, options);
}
const RejectInventoryMoveRequestDocument = lib/* gql */.Ps`
    mutation rejectInventoryMoveRequest($input: RejectInventoryMoveRequestInput!) {
  rejectInventoryMoveRequest(input: $input) {
    id
  }
}
    `;
function useRejectInventoryMoveRequestMutation(baseOptions) {
  const options = { ...useFulfillMoveRequestForm_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(RejectInventoryMoveRequestDocument, options);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.9/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(85961);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/fulfilment/validation.ts

const lotValidation = es.lazy(
  (lot) => es.object({
    quantity: lot.quantity === "" ? void 0 : es.number().min(0).max(lot.quantityAvailable)
  })
);
const skuValidation = es.lazy((lots = {}) => {
  return es.object(
    Object.keys(lots).reduce(
      (acc, lotId) => ({
        ...acc,
        [lotId]: lotValidation
      }),
      {}
    )
  );
});
const skusValidation = es.lazy((skus = {}) => {
  return es.object(
    Object.keys(skus).reduce(
      (acc, skuId) => ({
        ...acc,
        [skuId]: skuValidation
      }),
      {}
    )
  );
});
const validationSchema = es.object({
  skus: skusValidation,
  notes: es.string()
});

;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/fulfilment/useFulfillMoveRequestForm.tsx









lib/* gql */.Ps`
  mutation fulfillInventoryMoveRequest($input: FulfillInventoryMoveRequestInput!) {
    fulfillInventoryMoveRequest(input: $input) {
      id
    }
  }
`;
lib/* gql */.Ps`
  mutation rejectInventoryMoveRequest($input: RejectInventoryMoveRequestInput!) {
    rejectInventoryMoveRequest(input: $input) {
      id
    }
  }
`;
function transformFormValuesToFulfillments(formValues) {
  const fulfillments = [];
  Object.entries(formValues.skus || {}).forEach(([requestSkuId, lots]) => {
    Object.entries(lots).forEach(([lotId, { quantity }]) => {
      const quantityInt = parseInt(quantity, 10);
      if (quantityInt > 0) {
        fulfillments.push({
          requestSkuId,
          fulfillingLotId: lotId,
          quantity: parseInt(quantity, 10)
        });
      }
    });
  });
  return fulfillments;
}
function transformDataToDefaultFormValues(fulfillmentSkusData = []) {
  return {
    skus: fulfillmentSkusData.reduce(
      (acc, sku) => ({
        ...acc,
        [sku.id]: sku.availableLots.reduce(
          (lotAcc, lot) => ({
            ...lotAcc,
            [lot.id]: { quantityAvailable: lot.quantity }
          }),
          {}
        )
      }),
      {}
    )
  };
}
function useFulfillMoveRequestForm({ moveRequestId }) {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const navigate = (0,dist/* useNavigate */.s0)();
  const formMethods = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(validationSchema),
    mode: "onChange",
    reValidateMode: "onChange"
  });
  const [fulfillRequest, { loading }] = useFulfillInventoryMoveRequestMutation({
    onError: () => mui_toast_dist_default().error(
      formatMessage({
        id: "inventory.moveRequest.fulfill.error",
        defaultMessage: "Error Fulfilling Request"
      })
    ),
    onCompleted: () => {
      mui_toast_dist_default().success(
        formatMessage({
          id: "inventory.moveRequest.fulfill.success",
          defaultMessage: "Fulfilled Request"
        })
      );
      navigate((0,links/* linkToInventoryMoveRequests */.AC)());
    }
  });
  async function submit(formValues) {
    await fulfillRequest({
      variables: {
        input: {
          id: moveRequestId,
          fulfillments: transformFormValuesToFulfillments(formValues),
          notes: formValues.notes
        }
      }
    });
  }
  const [rejectRequest] = useRejectInventoryMoveRequestMutation({
    onError: () => mui_toast_dist_default().error(
      formatMessage({
        id: "inventory.moveRequest.reject.error",
        defaultMessage: "Error Rejecting Request"
      })
    ),
    onCompleted: () => {
      mui_toast_dist_default().success(
        formatMessage({
          id: "inventory.moveRequest.reject.success",
          defaultMessage: "Rejected Request"
        })
      );
      navigate((0,links/* linkToInventoryMoveRequests */.AC)());
    }
  });
  const notes = formMethods.watch("notes");
  const skus = formMethods.watch("skus");
  const disableSubmit = transformFormValuesToFulfillments({ skus }).length === 0;
  async function reject() {
    if (!notes) {
      formMethods.setError(
        "notes",
        {
          type: "focus",
          message: formatMessage({
            id: "inventory.moveRequest.reject.notesValidationError",
            defaultMessage: "Required"
          })
        },
        { shouldFocus: true }
      );
      return;
    }
    await rejectRequest({
      variables: {
        input: {
          id: moveRequestId,
          notes
        }
      }
    });
  }
  return {
    formMethods,
    onSubmit: formMethods.handleSubmit(submit),
    onReject: reject,
    resetSkuValues: (data = []) => formMethods.reset(transformDataToDefaultFormValues(data)),
    disableSubmit,
    loading
  };
}

// EXTERNAL MODULE: ./src/client/components/ErrorPage/index.tsx
var ErrorPage = __webpack_require__(64493);
// EXTERNAL MODULE: ./src/client/components/InfoField.tsx
var InfoField = __webpack_require__(33641);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/fulfilment/FulfillMoveRequest.tsx




















const FulfillMoveRequest = () => {
  var _a, _b, _c, _d, _e, _f, _g;
  const { moveRequestId } = (0,dist/* useParams */.UO)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { facilityId } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const [locationId, setLocationId] = (0,react.useState)(null);
  const {
    formMethods,
    onSubmit,
    onReject,
    resetSkuValues,
    disableSubmit,
    loading: submitLoading
  } = useFulfillMoveRequestForm({
    moveRequestId
  });
  const { data, error, loading } = useFulfillInventoryMoveRequestPageQuery({
    variables: {
      input: {
        id: moveRequestId
      },
      lotsInput: {
        fulfillingFacilityId: facilityId,
        fulfillingLocationId: locationId || "something so validation does not fail"
      }
    },
    fetchPolicy: "cache-and-network",
    onCompleted: (_data) => {
      resetSkuValues(_data == null ? void 0 : _data.inventoryMoveRequest.skus.items);
    }
  });
  function onLocationSelect(_locationId) {
    setLocationId(_locationId);
  }
  if (error) {
    return /* @__PURE__ */ react.createElement(ErrorPage/* default */.Z, {
      error
    });
  }
  return /* @__PURE__ */ react.createElement(ex_web_packages.LayoutWithSideMenu, null, /* @__PURE__ */ react.createElement(components/* InventoryHeader */.ae, null), /* @__PURE__ */ react.createElement(mui_page_dist.Page, {
    "data-dense": true
  }, /* @__PURE__ */ react.createElement(components/* InventoryTitleRow */.Ac, {
    backToLink: (0,links/* linkToInventoryMoveRequests */.AC)(),
    title: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "inventory.requests.fulfill.title",
      defaultMessage: "Fulfill Request"
    })
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexWrap: "wrap"
  }, /* @__PURE__ */ react.createElement(InfoField/* default */.Z, {
    id: "requestedDate",
    label: formatMessage({
      id: "inventory.requests.fulfill.requestedDate",
      defaultMessage: "Requested"
    }),
    value: (0,formatting/* formatDate */.p6)((_a = data == null ? void 0 : data.inventoryMoveRequest) == null ? void 0 : _a.createdAt),
    width: "120px"
  }), /* @__PURE__ */ react.createElement(InfoField/* default */.Z, {
    id: "requestedBy",
    label: formatMessage({
      id: "inventory.requests.fulfill.requestedBy",
      defaultMessage: "Requested By"
    }),
    value: (0,formatting/* formatUserName */.BD)((_b = data == null ? void 0 : data.inventoryMoveRequest) == null ? void 0 : _b.requestor),
    minWidth: "200px"
  }), /* @__PURE__ */ react.createElement(InfoField/* default */.Z, {
    id: "requestedLocation",
    label: formatMessage({
      id: "inventory.requests.fulfill.requestedLocation",
      defaultMessage: "Location of Request"
    }),
    value: (_e = (_d = (_c = data == null ? void 0 : data.inventoryMoveRequest) == null ? void 0 : _c.receivingLocation) == null ? void 0 : _d.name) != null ? _e : "",
    minWidth: "300px"
  }))), /* @__PURE__ */ react.createElement("form", {
    onSubmit
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    width: "300px"
  }, /* @__PURE__ */ react.createElement(LocationSelect/* LocationSelect */.AO, {
    id: "fulfillingLocationId",
    label: formatMessage({
      id: "inventory.requests.fulfill.fulfillingLocation",
      defaultMessage: "Send From Location"
    }),
    value: locationId,
    onChange: onLocationSelect
  })), /* @__PURE__ */ react.createElement(fulfilment_FulfillMoveRequestTable, {
    data: (_g = (_f = data == null ? void 0 : data.inventoryMoveRequest) == null ? void 0 : _f.skus) == null ? void 0 : _g.items,
    loading,
    childrenFetched: !!locationId
  }), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    marginTop: 2,
    marginBottom: 2
  }, /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* TextArea */.Kx, {
    name: "notes",
    label: formatMessage({
      id: "inventory.requests.fulfill.notes",
      defaultMessage: "Notes"
    })
  })), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    justifyContent: "space-between"
  }, /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "error",
    variant: "contained",
    onClick: onReject
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.moveRequest.fulfill.reject",
    defaultMessage: "Reject Request"
  })), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "primary",
    variant: "contained",
    type: "submit",
    startIcon: submitLoading ? void 0 : /* @__PURE__ */ react.createElement(mui_icon_dist_module.CheckIcon, {
      color: "white"
    }),
    disabled: disableSubmit || submitLoading
  }, submitLoading ? /* @__PURE__ */ react.createElement(CircularProgress/* default */.Z, null) : /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.moveRequest.fulfill.submit",
    defaultMessage: "Fulfill Request"
  })))))));
};
/* harmony default export */ const fulfilment_FulfillMoveRequest = (FulfillMoveRequest);

;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/fulfilment/index.ts



/***/ }),

/***/ 89467:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* reexport */ new_request_MoveRequestNew)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/ex-web-packages/index.ts
var ex_web_packages = __webpack_require__(26298);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-page@0.4.3_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-page/dist/index.js
var dist = __webpack_require__(48534);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var user_context_provider_dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var react_router_dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var mui_toast_dist = __webpack_require__(28841);
var mui_toast_dist_default = /*#__PURE__*/__webpack_require__.n(mui_toast_dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+ui-defaults@1.1.8_pvaqciwivcayhn7w2xjerm27q4/node_modules/@elephant-healthcare/ui-defaults/dist/module.js
var ui_defaults_dist_module = __webpack_require__(81358);
// EXTERNAL MODULE: ./src/client/inventory/components/LocationSelect/index.ts + 2 modules
var LocationSelect = __webpack_require__(93240);
// EXTERNAL MODULE: ./src/client/inventory/components/index.ts + 5 modules
var components = __webpack_require__(6944);
// EXTERNAL MODULE: ./src/client/inventory/routing/links.ts
var links = __webpack_require__(57706);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.9/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(85961);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/new-request/validation.ts

const validationSchema = es.object({
  skus: es.array().transform((field) => {
    const finalValue = field[field.length - 1];
    if (finalValue !== void 0 && (finalValue.sku === null || finalValue.quantity === null)) {
      return field.slice(0, -1);
    }
    return field;
  }).of(
    es.object({
      sku: es.object({
        id: es.string().required()
      }).required(),
      quantity: es.number().moreThan(0).required()
    })
  ),
  locationId: es.string().required()
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(40374);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
// EXTERNAL MODULE: ./src/client/inventory/form-components/RHFTextField.tsx
var RHFTextField = __webpack_require__(93004);
// EXTERNAL MODULE: ./src/client/inventory/components/SkuSearchInput.tsx
var SkuSearchInput = __webpack_require__(34010);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/new-request/useSkuRequestFormState.ts


function useSkuRequestFormState() {
  const { watch } = (0,index_esm/* useFormContext */.Gc)();
  const { fields, append, remove } = (0,index_esm/* useFieldArray */.Dq)({
    name: "skus"
  });
  const lastSku = watch(`skus.${fields.length - 1}.sku`);
  const lastQuantity = watch(`skus.${fields.length - 1}.quantity`);
  const makeEmptyRow = () => ({
    sku: null,
    quantity: null
  });
  (0,react.useEffect)(() => {
    if (fields.length === 0 || lastSku || lastQuantity) {
      append(makeEmptyRow());
    }
  }, [lastSku, lastQuantity, append]);
  return { fields, remove };
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/new-request/SkuRequestTable.tsx








function buildTableColumns({
  formatMessage,
  classes,
  remove,
  totalRows
}) {
  return [
    {
      field: "skuId",
      headerName: formatMessage({
        id: "inventory.moveMedication.requestNew.columnLabel.item",
        defaultMessage: "ITEM"
      }),
      flex: 16,
      renderCell: (_value, index) => {
        return /* @__PURE__ */ react.createElement(SkuSearchInput/* default */.Z, {
          name: `skus.${index}.sku`,
          analyticsEventName: "inventoryMoveRequest.newMoveRequest.skuSearch",
          classes: {
            root: classes.hiddenHelperText,
            inputRoot: classes.inputCellRoot
          },
          renderOption: (option) => /* @__PURE__ */ react.createElement(SkuSearchInput/* OptionWithStockLevel */.l, {
            ...option
          })
        });
      }
    },
    {
      field: "quantity",
      headerName: formatMessage({
        id: "inventory.moveMedication.requestNew.columnLabel.quantity",
        defaultMessage: "QUANTITY"
      }),
      flex: 4,
      renderCell: (_value, index) => {
        return /* @__PURE__ */ react.createElement(RHFTextField/* RHFTextField */.a, {
          name: `skus.${index}.quantity`,
          inputProps: { type: "number" },
          classes: {
            root: `${classes.hiddenHelperText} ${classes.textFieldRoot}`
          }
        });
      }
    },
    {
      field: "actions",
      flex: 1,
      renderCell: (_value, index) => {
        if (index === totalRows - 1) {
          return null;
        }
        return /* @__PURE__ */ react.createElement(IconButton/* default */.Z, {
          "aria-label": "edit",
          "aria-controls": "edit",
          onClick: () => {
            remove(index);
          }
        }, /* @__PURE__ */ react.createElement(mui_icon_dist_module.CrossIcon, {
          fill: "#004F71"
        }));
      }
    }
  ];
}
const useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  rowCellClass: {
    padding: theme.spacing(1)
  },
  inputCellRoot: {
    height: "56px"
  },
  hiddenHelperText: {
    "& .MuiFormHelperText-root": {
      display: "none"
    }
  },
  inputCellInput: {
    padding: "8px 0px"
  },
  textFieldRoot: {
    "& .MuiOutlinedInput-input": {
      padding: "8px 0px"
    }
  }
}));
const SkuRequestTable = () => {
  const classes = useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { fields, remove } = useSkuRequestFormState();
  const columns = buildTableColumns({
    formatMessage,
    classes,
    remove,
    totalRows: fields.length
  });
  return /* @__PURE__ */ react.createElement(ex_web_packages.Table, {
    columns,
    rows: fields,
    classes: { rowCellClass: () => classes.rowCellClass }
  });
};
/* harmony default export */ const new_request_SkuRequestTable = (SkuRequestTable);

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/new-request/__generated__/MoveRequestNew.gql.ts


const defaultOptions = {};
const RequestInventoryMoveDocument = lib/* gql */.Ps`
    mutation requestInventoryMove($input: RequestInventoryMoveInput!) {
  requestInventoryMove(input: $input) {
    id
  }
}
    `;
function useRequestInventoryMoveMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(RequestInventoryMoveDocument, options);
}

;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/new-request/MoveRequestNew.tsx



















lib/* gql */.Ps`
  mutation requestInventoryMove($input: RequestInventoryMoveInput!) {
    requestInventoryMove(input: $input) {
      # Don't bother caching any fields like requestor, as we're redirected to a page that has to fetch a list of requests anyway.
      id
    }
  }
`;
const MoveRequestNew = () => {
  const {
    value: { locationId: defaultLocationId },
    save: saveUiDefault
  } = (0,ui_defaults_dist_module/* useUiDefault */.k)({
    scope: ui_defaults_dist_module/* UiDefaultScope.User */.X.User,
    namespace: "elephant.inventory.moveRequestNew",
    name: "locationId",
    defaultValue: {}
  });
  const formMethods = (0,index_esm/* useForm */.cI)({
    defaultValues: { skus: [], locationId: defaultLocationId },
    resolver: (0,yup/* yupResolver */.X)(validationSchema),
    mode: "onSubmit",
    reValidateMode: "onChange"
  });
  (0,react.useEffect)(() => {
    if (!formMethods.getValues("locationId")) {
      formMethods.setValue("locationId", defaultLocationId);
    }
  }, [defaultLocationId, formMethods]);
  const { facilityId } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const navigate = (0,react_router_dist/* useNavigate */.s0)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [requestInventoryMove] = useRequestInventoryMoveMutation({
    onError: (error) => mui_toast_dist_default().error(error.message),
    onCompleted: () => mui_toast_dist_default().success(
      formatMessage({
        id: "inventory.moveRequest.new.notification.submit.success",
        defaultMessage: "Request Submitted"
      })
    )
  });
  const submit = async (data) => {
    saveUiDefault({ locationId: data.locationId });
    await requestInventoryMove({
      variables: {
        input: {
          receivingFacilityId: facilityId,
          receivingLocationId: data.locationId,
          skus: data.skus.map((sku) => ({
            skuId: sku.sku.id,
            quantityRequested: sku.quantity
          }))
        }
      }
    });
    navigate((0,links/* linkToInventoryMoveRequests */.AC)());
  };
  const skus = formMethods.watch("skus");
  const someSkusFilledIn = skus.some(({ quantity }) => quantity > 0);
  return /* @__PURE__ */ react.createElement(ex_web_packages.LayoutWithSideMenu, null, /* @__PURE__ */ react.createElement("form", {
    onSubmit: formMethods.handleSubmit(submit)
  }, /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement(components/* InventoryHeader */.ae, {
    rightContent: /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
      color: "primary",
      variant: "contained",
      type: "submit",
      startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.CheckIcon, {
        color: "white"
      }),
      disabled: !someSkusFilledIn
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "inventory.moveRequest.new.header.submit",
      defaultMessage: "Submit Request"
    }))
  }), /* @__PURE__ */ react.createElement(dist.Page, {
    "data-dense": true
  }, /* @__PURE__ */ react.createElement(components/* InventoryTitleRow */.Ac, {
    title: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "inventory.request.new.title",
      defaultMessage: "New Move Request"
    })
  }, /* @__PURE__ */ react.createElement("div", {
    style: { width: "250px" }
  }, /* @__PURE__ */ react.createElement(LocationSelect/* RHFLocationSelect */.N7, {
    id: "locationId",
    label: "Receiving Location"
  }))), /* @__PURE__ */ react.createElement(new_request_SkuRequestTable, null)))));
};
/* harmony default export */ const new_request_MoveRequestNew = (MoveRequestNew);

;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/new-request/index.ts



/***/ }),

/***/ 23323:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": () => (/* reexport */ request_list_ActionedMoveRequestOverview),
  "J": () => (/* reexport */ MoveRequests)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-page@0.4.3_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-page/dist/index.js
var mui_page_dist = __webpack_require__(48534);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./src/ex-web-packages/index.ts
var ex_web_packages = __webpack_require__(26298);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-icon@0.3.15_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-icon/dist/module.js
var mui_icon_dist_module = __webpack_require__(46828);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+role-definitions@3.0.0/node_modules/@elephant-healthcare/role-definitions/dist/module.js
var role_definitions_dist_module = __webpack_require__(4377);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+user-context-provider@1.3.0_whclspbtx7fcz5jo6nehkthzny/node_modules/@elephant-healthcare/user-context-provider/dist/module.js
var user_context_provider_dist_module = __webpack_require__(36547);
// EXTERNAL MODULE: ./src/client/inventory/components/LocationSelect/index.ts + 2 modules
var LocationSelect = __webpack_require__(93240);
// EXTERNAL MODULE: ./src/client/inventory/components/index.ts + 5 modules
var components = __webpack_require__(6944);
// EXTERNAL MODULE: ./src/client/inventory/routing/links.ts
var links = __webpack_require__(57706);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-input@0.3.5_atek3e5pugfjeukz7kzynbm6iy/node_modules/@elephant-healthcare/mui-input/dist/module.js
var mui_input_dist_module = __webpack_require__(34948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(64432);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(77572);
// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/StatusSelect.tsx





const StatusSelect_all = "ALL";
const StatusSelect = ({ value, onChange }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */ react.createElement(mui_input_dist_module/* SelectField */.mg, {
    name: "location",
    id: "move-request-status-select",
    fullWidth: true,
    hideHelper: true,
    label: formatMessage({
      id: "inventory.moveRequests.statusSelect.placeholder",
      defaultMessage: "Show Requests"
    }),
    selectProps: {
      value: value || StatusSelect_all,
      onChange: (e) => {
        const newValue = e.target.value;
        onChange(newValue === StatusSelect_all ? null : newValue);
      }
    }
  }, /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    value: base_gql/* InventoryMoveRequestStatus.Fulfilled */.xH.Fulfilled
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.overview.locationSelect.fulfilledOption",
    defaultMessage: "Fulfilled"
  })), /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    value: base_gql/* InventoryMoveRequestStatus.Pending */.xH.Pending
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.overview.locationSelect.pendingOption",
    defaultMessage: "Pending"
  })), /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    value: base_gql/* InventoryMoveRequestStatus.Rejected */.xH.Rejected
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.overview.locationSelect.rejectedOption",
    defaultMessage: "Rejected"
  })), /* @__PURE__ */ react.createElement(Divider/* default */.Z, null), /* @__PURE__ */ react.createElement(MenuItem/* default */.Z, {
    value: StatusSelect_all
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "inventory.overview.locationSelect.allRequestsOption",
    defaultMessage: "All"
  })));
};
/* harmony default export */ const move_requests_StatusSelect = (StatusSelect);

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./src/client/inventory/formatting.ts
var formatting = __webpack_require__(41907);
// EXTERNAL MODULE: ./src/client/inventory/components/UserName.tsx
var UserName = __webpack_require__(30623);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/index.js + 1 modules
var react_intl_lib = __webpack_require__(11313);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-chip@0.1.9_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-chip/dist/module.js
var mui_chip_dist_module = __webpack_require__(85810);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/StatusChip.tsx



const messages = (0,react_intl_lib/* defineMessages */.vU)({
  pending: {
    id: "inventory.moveRequests.status.pending",
    defaultMessage: "Pending"
  },
  rejected: {
    id: "inventory.moveRequests.status.rejected",
    defaultMessage: "Rejected"
  },
  fulfilled: {
    id: "inventory.moveRequests.status.fulfilled",
    defaultMessage: "Fulfilled"
  }
});
const StatusChip = ({ status }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  switch (status) {
    case "PENDING":
      return /* @__PURE__ */ react.createElement(mui_chip_dist_module/* Chip */.A, {
        label: formatMessage(messages.pending),
        color: "darkerGrey"
      });
    case "REJECTED":
      return /* @__PURE__ */ react.createElement(mui_chip_dist_module/* Chip */.A, {
        label: formatMessage(messages.rejected),
        color: "prescription"
      });
    case "FULFILLED":
      return /* @__PURE__ */ react.createElement(mui_chip_dist_module/* Chip */.A, {
        label: formatMessage(messages.fulfilled),
        color: "primary"
      });
    default:
      return null;
  }
};
/* harmony default export */ const move_requests_StatusChip = (StatusChip);

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/request-list/__generated__/MoveRequestsTable.gql.ts


const defaultOptions = {};
const InventoryMoveRequestsListDocument = lib/* gql */.Ps`
    query inventoryMoveRequestsList($input: InventoryMoveRequestsInput!, $options: InventoryMoveRequestsOptions) {
  inventoryMoveRequests(input: $input, options: $options) {
    totalCount
    items {
      id
      createdAt
      status
      receivingLocation {
        name
      }
      requestor {
        person {
          firstname
          lastname
        }
      }
      actionedAt
      actionerNotes
    }
  }
}
    `;
function useInventoryMoveRequestsListQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(InventoryMoveRequestsListDocument, options);
}
function useInventoryMoveRequestsListLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InventoryMoveRequestsListDocument, options);
}

// EXTERNAL MODULE: ./src/client/components/ErrorPage/index.tsx
var ErrorPage = __webpack_require__(64493);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/request-list/MoveRequestsTable.tsx









lib/* gql */.Ps`
  query inventoryMoveRequestsList(
    $input: InventoryMoveRequestsInput!
    $options: InventoryMoveRequestsOptions
  ) {
    inventoryMoveRequests(input: $input, options: $options) {
      totalCount
      items {
        id
        createdAt
        status
        receivingLocation {
          name
        }
        requestor {
          person {
            firstname
            lastname
          }
        }
        actionedAt
        actionerNotes
      }
    }
  }
`;
const MoveRequestsTable = ({
  receivingLocationId,
  onRowClick,
  status,
  pageSize = 20
}) => {
  var _a, _b, _c;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const tableColumns = [
    {
      field: "createdAt",
      headerName: formatMessage({
        id: "inventory.moveRequests.table.columnLabel.createdAt",
        defaultMessage: "Date Requested"
      }),
      flex: 1
    },
    {
      field: "locationName",
      headerName: formatMessage({
        id: "inventory.moveRequests.table.columnLabel.locationName",
        defaultMessage: "Location"
      }),
      flex: 2
    },
    {
      field: "requestedBy",
      headerName: formatMessage({
        id: "inventory.moveRequests.table.columnLabel.requestedBy",
        defaultMessage: "Requested By"
      }),
      flex: 2,
      renderCell: (val) => /* @__PURE__ */ react.createElement(UserName/* default */.Z, {
        name: val
      })
    },
    {
      field: "status",
      headerName: formatMessage({
        id: "inventory.moveRequests.table.columnLabel.status",
        defaultMessage: "Status"
      }),
      flex: 1,
      renderCell: (_status) => /* @__PURE__ */ react.createElement(move_requests_StatusChip, {
        status: _status
      })
    },
    {
      field: "actionedAt",
      headerName: formatMessage({
        id: "inventory.moveRequests.table.columnLabel.actionedAt",
        defaultMessage: "Date Processed"
      }),
      flex: 1
    },
    {
      field: "actionerNotes",
      headerName: formatMessage({
        id: "inventory.moveRequests.table.columnLabel.actionerNotes",
        defaultMessage: "Notes"
      }),
      flex: 3,
      renderCell: (notes) => /* @__PURE__ */ react.createElement("div", {
        style: {
          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          maxWidth: "512px"
        }
      }, notes)
    }
  ];
  const [currentPage, setCurrentPage] = (0,react.useState)(0);
  const { data, loading, error } = useInventoryMoveRequestsListQuery({
    variables: {
      input: {
        receivingLocationId,
        status
      },
      options: {
        pageNumber: currentPage,
        pageSize
      }
    },
    fetchPolicy: "cache-and-network",
    pollInterval: 30 * 1e3
  });
  if (error) {
    return /* @__PURE__ */ react.createElement(ErrorPage/* default */.Z, {
      error
    });
  }
  const mappedData = (_b = (_a = data == null ? void 0 : data.inventoryMoveRequests) == null ? void 0 : _a.items) == null ? void 0 : _b.map((item) => {
    return {
      id: item.id,
      createdAt: (0,formatting/* formatDate */.p6)(item.createdAt),
      locationName: item.receivingLocation.name,
      requestedBy: (0,formatting/* formatUserName */.BD)(item.requestor),
      status: item.status,
      actionedAt: (0,formatting/* formatDate */.p6)(item.actionedAt),
      actionerNotes: item.actionerNotes
    };
  });
  return /* @__PURE__ */ react.createElement(ex_web_packages.Table, {
    loading,
    columns: tableColumns,
    rows: mappedData != null ? mappedData : [],
    noDataMessage: formatMessage({
      id: "inventory.moveRequests.list.noData",
      defaultMessage: "No requests found."
    }),
    onRowClick: (row) => onRowClick({ id: row.id, status: row.status }),
    pagination: {
      page: currentPage,
      pageSize,
      totalRows: (_c = data == null ? void 0 : data.inventoryMoveRequests) == null ? void 0 : _c.totalCount,
      handlePageChange: (newPageNumber) => {
        setCurrentPage(newPageNumber);
      }
    }
  });
};
/* harmony default export */ const request_list_MoveRequestsTable = (MoveRequestsTable);

;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/request-list/MoveRequests.tsx















function MoveRequests() {
  const [statusFilter, setStatusFilter] = (0,react.useState)(null);
  const [locationId, setLocationId] = (0,react.useState)(null);
  const { roleName } = (0,user_context_provider_dist_module/* useUserContext */.SE)();
  const navigate = (0,dist/* useNavigate */.s0)();
  function onStatusChange(status) {
    setStatusFilter(status);
  }
  return /* @__PURE__ */ react.createElement(ex_web_packages.LayoutWithSideMenu, null, /* @__PURE__ */ react.createElement(components/* InventoryHeader */.ae, {
    rightContent: /* @__PURE__ */ react.createElement(dist_module/* LinkButton */.Qj, {
      to: (0,links/* linkToInventoryMoveRequestNew */.CQ)(),
      startIcon: /* @__PURE__ */ react.createElement(mui_icon_dist_module.StockRequestsIcon, null)
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "inventory.requests.button.newRequest",
      defaultMessage: "New Request"
    }))
  }), /* @__PURE__ */ react.createElement(mui_page_dist.Page, {
    "data-dense": true
  }, /* @__PURE__ */ react.createElement(components/* InventoryTitleRow */.Ac, {
    title: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "inventory.requests.title",
      defaultMessage: "Inventory Requests"
    })
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    spacing: 2,
    justifyContent: "space-between",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    sm: "auto"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    minWidth: "300px"
  }, /* @__PURE__ */ react.createElement(LocationSelect/* LocationSelectWithAllOption */.es, {
    value: locationId,
    onChange: setLocationId
  }))), /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    item: true,
    xs: 12,
    sm: "auto"
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    minWidth: "140px"
  }, /* @__PURE__ */ react.createElement(move_requests_StatusSelect, {
    value: statusFilter,
    onChange: onStatusChange
  }))))), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    marginTop: 4
  }, /* @__PURE__ */ react.createElement(request_list_MoveRequestsTable, {
    status: statusFilter,
    receivingLocationId: locationId,
    onRowClick: ({ id, status: rowStatus }) => {
      navigate(
        rowStatus === "PENDING" && roleName === role_definitions_dist_module/* Role.PHARMACIST */.uU.PHARMACIST ? (0,links/* linkToFulfillInventoryMoveRequest */.St)(id) : (0,links/* linkToInventoryMoveRequestOverview */.HW)(id)
      );
    }
  }))));
}

// EXTERNAL MODULE: ./src/client/inventory/components/ExpiryCell.tsx
var ExpiryCell = __webpack_require__(96425);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/request-list/ActionedMoveRequestOverviewTable.tsx





function mapFetchedDataToTableData(data = []) {
  return data.map((requestSku) => {
    return {
      header: {
        id: requestSku.id,
        skuName: requestSku.sku.name,
        quantityRequested: requestSku.quantityRequested,
        quantityFulfilled: requestSku.fulfillments.reduce(
          (total, fulfillment) => total + fulfillment.quantityFulfilled,
          0
        )
      },
      children: requestSku.fulfillments.map((fulfillment) => ({
        id: fulfillment.id,
        expiryDate: fulfillment.fulfillingLot.expiryDate,
        quantityFulfilled: fulfillment.quantityFulfilled
      }))
    };
  });
}
const ActionedMoveRequestOverviewTable = ({
  loading,
  data
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const columns = [
    {
      field: "skuName",
      headerName: formatMessage({
        id: "inventory.moveRequest.actionedTable.columnLabel.skuName",
        defaultMessage: "Requested Item"
      }),
      flex: 3
    },
    {
      field: "quantitySent",
      headerName: formatMessage({
        id: "inventory.moveRequest.actionedTable.columnLabel.quantitySent",
        defaultMessage: "Quantity Sent"
      }),
      flex: 1,
      renderCell: (_, _index, _column, row) => {
        if (!("skuName" in row)) {
          return /* @__PURE__ */ react.createElement(react.Fragment, null, row.quantityFulfilled);
        }
        let color = "primary";
        if (row.quantityFulfilled < row.quantityRequested) {
          color = "prescription";
        }
        return /* @__PURE__ */ react.createElement(mui_chip_dist_module/* Chip */.A, {
          label: `${row.quantityFulfilled} / ${row.quantityRequested}`,
          color
        });
      }
    },
    {
      field: "expiryDate",
      headerName: formatMessage({
        id: "inventory.fulfillmoveRequest.table.columnLabel.expiryDate",
        defaultMessage: "Expiry Date"
      }),
      flex: 1,
      renderCell: (expiryDate) => expiryDate ? /* @__PURE__ */ react.createElement(ExpiryCell/* default */.Z, {
        expiryDate
      }) : ""
    }
  ];
  return /* @__PURE__ */ react.createElement(ex_web_packages.Table, {
    loading,
    columns,
    expandingGroups: true,
    rows: mapFetchedDataToTableData(data)
  });
};
/* harmony default export */ const request_list_ActionedMoveRequestOverviewTable = (ActionedMoveRequestOverviewTable);

;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/request-list/__generated__/ActionedMoveRequestOverview.gql.ts


const ActionedMoveRequestOverview_gql_defaultOptions = {};
const ActionedInventoryMoveRequestOverviewDocument = lib/* gql */.Ps`
    query actionedInventoryMoveRequestOverview($input: InventoryMoveRequestInput!) {
  inventoryMoveRequest(input: $input) {
    id
    status
    createdAt
    requestor {
      person {
        firstname
        lastname
      }
    }
    actionedAt
    actionerNotes
    actioner {
      person {
        firstname
        lastname
      }
    }
    receivingLocation {
      name
    }
    skus {
      items {
        id
        quantityRequested
        sku {
          name
        }
        fulfillments {
          id
          quantityFulfilled
          fulfillingLot {
            expiryDate
          }
        }
      }
    }
  }
}
    `;
function useActionedInventoryMoveRequestOverviewQuery(baseOptions) {
  const options = { ...ActionedMoveRequestOverview_gql_defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(ActionedInventoryMoveRequestOverviewDocument, options);
}
function useActionedInventoryMoveRequestOverviewLazyQuery(baseOptions) {
  const options = { ...ActionedMoveRequestOverview_gql_defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(ActionedInventoryMoveRequestOverviewDocument, options);
}

// EXTERNAL MODULE: ./src/client/components/InfoField.tsx
var InfoField = __webpack_require__(33641);
;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/request-list/ActionedMoveRequestOverview.tsx














lib/* gql */.Ps`
  query actionedInventoryMoveRequestOverview($input: InventoryMoveRequestInput!) {
    inventoryMoveRequest(input: $input) {
      id
      status
      createdAt
      requestor {
        person {
          firstname
          lastname
        }
      }
      actionedAt
      actionerNotes
      actioner {
        person {
          firstname
          lastname
        }
      }
      receivingLocation {
        name
      }

      skus {
        items {
          id
          quantityRequested
          sku {
            name
          }
          fulfillments {
            id
            quantityFulfilled
            fulfillingLot {
              expiryDate
            }
          }
        }
      }
    }
  }
`;
const ActionedMoveRequestOverview = () => {
  var _a, _b;
  const { moveRequestId } = (0,dist/* useParams */.UO)();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { data, loading } = useActionedInventoryMoveRequestOverviewQuery({
    variables: {
      input: {
        id: moveRequestId
      }
    }
  });
  const request = data == null ? void 0 : data.inventoryMoveRequest;
  return /* @__PURE__ */ react.createElement(ex_web_packages.LayoutWithSideMenu, null, /* @__PURE__ */ react.createElement(components/* InventoryHeader */.ae, null), /* @__PURE__ */ react.createElement(mui_page_dist.Page, {
    "data-dense": true
  }, /* @__PURE__ */ react.createElement(components/* InventoryTitleRow */.Ac, {
    backToLink: (0,links/* linkToInventoryMoveRequests */.AC)(),
    title: /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      display: "flex",
      alignItems: "center"
    }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "inventory.requests.overview.title",
      defaultMessage: "Request"
    }), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
      marginLeft: 2
    }, /* @__PURE__ */ react.createElement(move_requests_StatusChip, {
      status: request == null ? void 0 : request.status
    })))
  }, /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center"
  }, /* @__PURE__ */ react.createElement(InfoField/* default */.Z, {
    id: "requestedAt",
    label: formatMessage({
      id: "inventory.requests.overview.requestedDate",
      defaultMessage: "Requested"
    }),
    value: (0,formatting/* formatDate */.p6)(request == null ? void 0 : request.createdAt),
    width: "120px"
  }), /* @__PURE__ */ react.createElement(InfoField/* default */.Z, {
    id: "requestedBy",
    label: formatMessage({
      id: "inventory.requests.overview.requestedBy",
      defaultMessage: "Requested By"
    }),
    value: (0,formatting/* formatUserName */.BD)(request == null ? void 0 : request.requestor),
    minWidth: "200px"
  }), /* @__PURE__ */ react.createElement(InfoField/* default */.Z, {
    id: "actionedAt",
    label: formatMessage({
      id: "inventory.requests.overview.actinoedAt",
      defaultMessage: "Processed"
    }),
    value: (0,formatting/* formatDate */.p6)(request == null ? void 0 : request.actionedAt),
    width: "120px"
  }), /* @__PURE__ */ react.createElement(InfoField/* default */.Z, {
    id: "actionedBy",
    label: formatMessage({
      id: "inventory.requests.overview.actionedBy",
      defaultMessage: "Processed By"
    }),
    value: (0,formatting/* formatUserName */.BD)(request == null ? void 0 : request.actioner),
    minWidth: "200px"
  }), /* @__PURE__ */ react.createElement(InfoField/* default */.Z, {
    id: "requestedLocation",
    label: formatMessage({
      id: "inventory.requests.overview.requestedLocation",
      defaultMessage: "Location of Request"
    }),
    value: (_b = (_a = request == null ? void 0 : request.receivingLocation) == null ? void 0 : _a.name) != null ? _b : "",
    minWidth: "300px"
  }))), (request == null ? void 0 : request.actionerNotes) && /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    marginTop: 3
  }, /* @__PURE__ */ react.createElement(InfoField/* default */.Z, {
    id: "notes",
    label: formatMessage({
      id: "inventory.requests.overview.notes",
      defaultMessage: "Notes"
    }),
    value: request == null ? void 0 : request.actionerNotes,
    multiline: true,
    fullWidth: true,
    rows: 3
  })), /* @__PURE__ */ react.createElement(Box/* default */.Z, {
    marginTop: 3
  }, /* @__PURE__ */ react.createElement(request_list_ActionedMoveRequestOverviewTable, {
    loading,
    data: request == null ? void 0 : request.skus.items
  }))));
};
/* harmony default export */ const request_list_ActionedMoveRequestOverview = (ActionedMoveRequestOverview);

;// CONCATENATED MODULE: ./src/client/inventory/pages/move-requests/request-list/index.ts




/***/ })

}]);